(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["lucide-avis-clients"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('lucide-avis-clients')) {
    customElements.define(
      'lucide-avis-clients',
      class extends HTMLElement {
        connectedCallback() {
          this.rail = this.querySelector('[data-lav-rail]');
          this.compteur = this.querySelector('[data-lav-compteur]');
          if (!this.rail) return;
          this.cartes = Array.from(this.rail.querySelectorAll('.lavx'));
          this.rail.addEventListener('scroll', () => this.marquer(), { passive: true });
          this.marquer();
          var prec = this.querySelector('[data-lav-prec]');
          var suiv = this.querySelector('[data-lav-suiv]');
          if (prec) prec.addEventListener('click', () => this.allerA(this.indexCourant() - 1));
          if (suiv) suiv.addEventListener('click', () => this.allerA(this.indexCourant() + 1));

          /* le client lance une vidéo (bouton ou image) : les autres s'arrêtent ; 2e appui = pause */
          this.addEventListener('click', (e) => {
            if (e.target.closest('.lavx__vignette')) return;
            var zone = e.target.closest('[data-lav-pause], .lavx--video .lavx__media');
            if (!zone) return;
            var carte = zone.closest('.lavx');
            var video = carte && carte.querySelector('video');
            if (!video) return;
            if (video.paused) {
              this.arreterTout(video);
              video.muted = false;
              video.play().catch(function () {});
            } else {
              video.pause();
            }
          });
          this.videos = Array.from(this.rail.querySelectorAll('video'));
          this.videos.forEach(function (v) {
            var carte = v.closest('.lavx');
            var bouton = carte.querySelector('[data-lav-pause]');
            v.addEventListener('play', function () { carte.classList.add('lavx--joue'); if (bouton) bouton.setAttribute('aria-label', 'Mettre en pause'); });
            v.addEventListener('pause', function () { carte.classList.remove('lavx--joue'); if (bouton) bouton.setAttribute('aria-label', 'Lire la vidéo'); });
            v.addEventListener('ended', function () { carte.classList.remove('lavx--joue'); });
          });
          /* une vidéo qui sort de l'écran (swipe, défilement) s'arrête */
          if ('IntersectionObserver' in window) {
            this.obs = new IntersectionObserver(function (entrees) {
              entrees.forEach(function (en) { if (!en.isIntersecting || en.intersectionRatio < 0.5) en.target.pause(); });
            }, { threshold: [0, 0.5] });
            this.videos.forEach((v) => this.obs.observe(v));
          }

          this.addEventListener('shopify:block:select', (e) => {
            var carte = e.target.closest ? e.target.closest('.lavx') : null;
            var i = this.cartes.indexOf(carte);
            if (i >= 0) this.allerA(i);
          });
        }

        arreterTout(sauf) {
          (this.videos || []).forEach(function (v) { if (v !== sauf && !v.paused) v.pause(); });
        }

        disconnectedCallback() {
          if (this.obs) this.obs.disconnect();
        }

        /* première carte entièrement à gauche du rail (accrochage « start ») */
        indexCourant() {
          var bord = this.rail.scrollLeft + parseFloat(getComputedStyle(this.rail).paddingLeft || 0);
          var meilleur = 0;
          var ecartMini = Infinity;
          this.cartes.forEach(function (c, i) {
            var ecart = Math.abs(c.offsetLeft - bord);
            if (ecart < ecartMini) { ecartMini = ecart; meilleur = i; }
          });
          return meilleur;
        }

        marquer() {
          /* une vidéo dont la carte a quitté le cadre du carrousel s'arrête (swipe) */
          var cadre = this.rail.getBoundingClientRect();
          (this.videos || []).forEach(function (v) {
            if (v.paused) return;
            var b = v.closest('.lavx').getBoundingClientRect();
            var visible = Math.min(b.right, cadre.right) - Math.max(b.left, cadre.left);
            if (visible < b.width / 2) v.pause();
          });
          if (!this.compteur || !this.cartes.length) return;
          this.compteur.textContent = (this.indexCourant() + 1) + '-' + this.cartes.length;
        }

        /* Défilement animé maison (patron lucide-mur-avis) : le scroll-snap annule un
           scrollTo 'smooth', et requestAnimationFrame est gelé en arrière-plan — d'où le
           filet setTimeout qui pose la position finale et rend l'accrochage. */
        allerA(i) {
          var n = this.cartes.length;
          if (!n) return;
          i = Math.max(0, Math.min(i, n - 1));
          var pad = parseFloat(getComputedStyle(this.rail).paddingLeft || 0);
          var cible = this.cartes[i].offsetLeft - pad;
          cible = Math.max(0, Math.min(cible, this.rail.scrollWidth - this.rail.clientWidth));
          var depart = this.rail.scrollLeft;
          if (Math.abs(cible - depart) < 1) return;
          var snapAvant = this.rail.style.scrollSnapType;
          this.rail.style.scrollSnapType = 'none';
          var fini = false;
          var self = this;
          function terminer() {
            if (fini) return;
            fini = true;
            self.rail.scrollLeft = cible;
            self.rail.style.scrollSnapType = snapAvant;
            self.marquer();
          }
          if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) { terminer(); return; }
          var duree = 340;
          var debut = null;
          function image(t) {
            if (fini) return;
            if (debut === null) debut = t;
            var p = Math.min((t - debut) / duree, 1);
            var e = p < 0.5 ? 2 * p * p : 1 - Math.pow(-2 * p + 2, 2) / 2;
            self.rail.scrollLeft = depart + (cible - depart) * e;
            if (p < 1) requestAnimationFrame(image); else terminer();
          }
          requestAnimationFrame(image);
          setTimeout(terminer, duree + 80);
        }
      }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["lucide-avis-defile"] && !Shopify.designMode) return;
  try {
    
  (function () {
    if (window.lucideAvdInit) return;
    window.lucideAvdInit = true;

    function initTous() {
      document.querySelectorAll('.lucide-avd').forEach(function (racine) {
        if (racine.dataset.lucideAvdPret) return;
        racine.dataset.lucideAvdPret = '1';
        var rail = racine.querySelector('[data-lucide-avd-rail]');
        var prec = racine.querySelector('[data-lucide-avd-prec]');
        var suiv = racine.querySelector('[data-lucide-avd-suiv]');
        var curseur = racine.querySelector('[data-lucide-avd-curseur]');
        if (!rail) return;

        function pas() {
          var carte = rail.querySelector('.lucide-avg');
          return carte ? carte.getBoundingClientRect().width + 20 : rail.clientWidth * 0.8;
        }
        function maj() {
          var max = rail.scrollWidth - rail.clientWidth;
          if (prec) prec.disabled = rail.scrollLeft <= 2;
          if (suiv) suiv.disabled = rail.scrollLeft >= max - 2;
          if (curseur && rail.scrollWidth > 0) {
            var part = rail.clientWidth / rail.scrollWidth;
            curseur.style.width = Math.max(part * 100, 8) + '%';
            var avance = max > 0 ? rail.scrollLeft / max : 0;
            curseur.style.left = avance * (100 - Math.max(part * 100, 8)) + '%';
          }
        }
        if (prec) prec.addEventListener('click', function () { rail.scrollBy({ left: -pas(), behavior: 'smooth' }); });
        if (suiv) suiv.addEventListener('click', function () { rail.scrollBy({ left: pas(), behavior: 'smooth' }); });
        rail.addEventListener('scroll', function () { setTimeout(maj, 60); });
        window.addEventListener('resize', maj);
        maj();

        /* Glisser à la souris (le doigt défile déjà en natif) */
        var saisie = null;
        rail.addEventListener('pointerdown', function (e) {
          if (e.pointerType !== 'mouse') return;
          saisie = { x: e.clientX, depart: rail.scrollLeft };
          rail.classList.add('est-saisi');
        });
        rail.addEventListener('pointermove', function (e) {
          if (!saisie) return;
          rail.scrollLeft = saisie.depart - (e.clientX - saisie.x);
        });
        ['pointerup', 'pointercancel', 'pointerleave'].forEach(function (evt) {
          rail.addEventListener(evt, function () { saisie = null; rail.classList.remove('est-saisi'); });
        });
      });
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', initTous);
    } else {
      initTous();
    }
    document.addEventListener('shopify:section:load', function (e) {
      if (e.target.querySelector && e.target.querySelector('.lucide-avd')) {
        e.target.querySelectorAll('.lucide-avd').forEach(function (r) { delete r.dataset.lucideAvdPret; });
        initTous();
      }
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["lucide-bandeau-etudes"] && !Shopify.designMode) return;
  try {
    
  (function () {
    /* Patron d'ancre de lucide-liens, dupliqué sous garde PROPRE (un bloc
       porte son JS) : révéler l'onglet caché (lucide:reveler, écouté par la
       FAQ à onglets), ouvrir la question fermée, puis glisser. */
    if (window.lucideBandeauAncre) return;
    window.lucideBandeauAncre = true;
    document.addEventListener('click', function (e) {
      var lien = e.target.closest('[data-lbe-ancre]');
      if (!lien) return;
      var id = (lien.getAttribute('href') || '').slice(1);
      var cible = id && document.getElementById(id);
      if (!cible) return;
      e.preventDefault();
      document.dispatchEvent(new CustomEvent('lucide:reveler', { detail: cible }));
      var pliage = cible.closest('details');
      if (pliage) pliage.open = true;
      /* Calibrage (Omar 29/08) : une cible dans une FAQ à onglets fait
         défiler jusqu'au SOMMET de la FAQ (titre + pastilles visibles),
         pas au ras des questions avec le pied qui dépasse. */
      var defile = cible.closest('.lucide-fi') || cible;
      defile.style.scrollMarginTop = '90px';
      var douceur = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth';
      defile.scrollIntoView({ behavior: douceur, block: 'start' });
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["lucide-barre-nav"] && !Shopify.designMode) return;
  try {
    
  (function () {
    if (window.lucideBnInit) return;
    window.lucideBnInit = true;

    function initTous() {
      document.querySelectorAll('.lucide-bn').forEach(function (racine) {
        if (racine.dataset.lucideBnPret) return;
        racine.dataset.lucideBnPret = '1';
        var onglets = Array.prototype.slice.call(racine.querySelectorAll('.lucide-bn__onglet'));
        if (!onglets.length) return;

        function activer(actif) {
          onglets.forEach(function (o) { o.classList.toggle('est-actif', o === actif); });
        }

        /* Clic : défilement doux vers la cible, ouverture d'une question FAQ
           fermée, onglet marqué actif tout de suite */
        var douceur = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth';
        onglets.forEach(function (onglet) {
          var id = onglet.getAttribute('data-lucide-bn-cible');
          if (!id) return;
          onglet.addEventListener('click', function (e) {
            var cible = document.getElementById(id);
            if (!cible) return;
            e.preventDefault();
            /* Si la cible vit dans un onglet de FAQ caché, le révéler d'abord */
            document.dispatchEvent(new CustomEvent('lucide:reveler', { detail: cible }));
            var pliage = cible.closest('details');
            if (pliage) pliage.open = true;
            cible.scrollIntoView({ behavior: douceur, block: 'start' });
            activer(onglet);
          });
        });

        /* Onglet actif automatique : le trait suit la section que le client
           regarde (bande du tiers haut de l'écran) */
        if (racine.hasAttribute('data-lucide-bn-auto') && 'IntersectionObserver' in window) {
          var correspondance = new Map();
          onglets.forEach(function (onglet) {
            var id = onglet.getAttribute('data-lucide-bn-cible');
            var cible = id && document.getElementById(id);
            if (cible) correspondance.set(cible, onglet);
          });
          if (correspondance.size) {
            var observateur = new IntersectionObserver(function (entrees) {
              entrees.forEach(function (entree) {
                if (entree.isIntersecting) activer(correspondance.get(entree.target));
              });
            }, { rootMargin: '-25% 0px -65% 0px' });
            correspondance.forEach(function (onglet, cible) { observateur.observe(cible); });
          }
        }

        /* Au départ : le premier onglet est marqué (comme la source) */
        activer(onglets[0]);
      });
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', initTous);
    } else {
      initTous();
    }
    document.addEventListener('shopify:section:load', function (e) {
      if (e.target.querySelector && e.target.querySelector('.lucide-bn')) {
        e.target.querySelectorAll('.lucide-bn').forEach(function (r) { delete r.dataset.lucideBnPret; });
        initTous();
      }
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["lucide-benefice"] && !Shopify.designMode) return;
  try {
    
  (() => {
    if (customElements.get('lucide-benefice')) return;
    /* Apparition au défilement, rejouée à chaque passage : visible à 18 %, recaché une fois sorti de
       l'écran. Cartes décalées comme chez Magna (rangée 80 ms, colonne de droite +40 ms). */
    class LucideBenefice extends HTMLElement {
      connectedCallback() {
        const calme = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
        if (calme || (window.Shopify && window.Shopify.designMode) || !('IntersectionObserver' in window)) return;
        this.querySelectorAll('.lbf__carte').forEach((carte, i) => {
          carte.style.setProperty('--lbf-delai', `${Math.floor(i / 2) * 80 + (i % 2) * 40}ms`);
        });
        this.classList.add('lbf--anime');
        this.obs = new IntersectionObserver((entrees) => {
          entrees.forEach((x) => {
            if (x.intersectionRatio >= 0.18) x.target.classList.add('est-vu');
            else if (!x.isIntersecting) x.target.classList.remove('est-vu');
          });
        }, { threshold: [0, 0.18] });
        this.querySelectorAll('[data-lbf-montre]').forEach((el) => this.obs.observe(el));
      }

      disconnectedCallback() {
        if (this.obs) this.obs.disconnect();
      }
    }
    customElements.define('lucide-benefice', LucideBenefice);
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["lucide-carrousel-ingredients"] && !Shopify.designMode) return;
  try {
    
  (function () {
    if (window.lucideCiInit) return;
    window.lucideCiInit = true;

    function initTous() {
      document.querySelectorAll('.lucide-ci').forEach(function (racine) {
        if (racine.dataset.lucideCiPret) return;
        racine.dataset.lucideCiPret = '1';
        var rail = racine.querySelector('[data-lucide-ci-rail]');
        var prec = racine.querySelector('[data-lucide-ci-prec]');
        var suiv = racine.querySelector('[data-lucide-ci-suiv]');
        var curseur = racine.querySelector('[data-lucide-ci-curseur]');
        if (!rail) return;

        function pas() {
          var carte = rail.querySelector('.lucide-cic');
          return carte ? carte.getBoundingClientRect().width + 16 : rail.clientWidth * 0.8;
        }
        function maj() {
          var max = rail.scrollWidth - rail.clientWidth;
          if (prec) prec.disabled = rail.scrollLeft <= 2;
          if (suiv) suiv.disabled = rail.scrollLeft >= max - 2;
          if (curseur && rail.scrollWidth > 0) {
            var part = rail.clientWidth / rail.scrollWidth;
            curseur.style.width = Math.max(part * 100, 8) + '%';
            var avance = max > 0 ? rail.scrollLeft / max : 0;
            curseur.style.left = avance * (100 - Math.max(part * 100, 8)) + '%';
          }
        }
        if (prec) prec.addEventListener('click', function () { rail.scrollBy({ left: -pas(), behavior: 'smooth' }); });
        if (suiv) suiv.addEventListener('click', function () { rail.scrollBy({ left: pas(), behavior: 'smooth' }); });
        rail.addEventListener('scroll', function () { setTimeout(maj, 60); });
        window.addEventListener('resize', maj);
        maj();

        /* Les liens-documents naissent dans le rail (seul berceau des blocs) :
           on les déplace dans leur zone — au-dessus des cartes ou dans la pile
           du bas, selon leur réglage. */
        var liensHaut = racine.querySelector('[data-lucide-ci-liens-haut]');
        var liensBas = racine.querySelector('[data-lucide-ci-liens-bas]');
        racine.querySelectorAll('[data-lucide-ci-doc]').forEach(function (doc) {
          var zone = doc.dataset.position === 'dessus' ? liensHaut : liensBas;
          if (zone && doc.parentElement !== zone) zone.appendChild(doc);
        });
      });
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', initTous);
    } else {
      initTous();
    }
    document.addEventListener('shopify:section:load', function (e) {
      if (e.target.querySelector && e.target.querySelector('.lucide-ci')) {
        e.target.querySelectorAll('.lucide-ci').forEach(function (r) { delete r.dataset.lucideCiPret; });
        initTous();
      }
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["lucide-carte-ingredients"] && !Shopify.designMode) return;
  try {
    
  /* Carte des ingrédients : ouverture au clic (lien #ancre), liste, onglets, fiche, éditeur.
     Le dessin de la carte vit dans assets/lucide-carte-ingredients.js, chargé à la première ouverture. */
  (() => {
    if (customElements.get('lucide-carte-ingredients')) return;
    const CARTES = new Set();
    const RESTENT_OUVERTES = new Set();
    /* éditeur : chaque réglage modifié redessine la section ; on rouvre sur le même ingrédient, au même endroit */
    const DERNIERS = new Map();
    const calme = () => window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    const echapper = (t) => String(t == null ? '' : t).replace(/[&<>"']/g, (x) => ({ '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' })[x]);
    const nombre = (v, defaut) => { const n = parseFloat(String(v == null ? '' : v).replace(',', '.')); return Number.isFinite(n) ? n : defaut; };
    const chargerScript = (src) => new Promise((ok, ko) => {
      const s = document.createElement('script');
      s.src = src; s.async = true; s.onload = () => ok(); s.onerror = () => ko(new Error(src));
      document.head.appendChild(s);
    });
    let moteur = null;
    const preparerMoteur = (el) => {
      if (!moteur) {
        moteur = (async () => {
          if (!window.LucideCarte) await chargerScript(el.dataset.moteur);
          return window.LucideCarte.charger({ d3: el.dataset.d3, topojson: el.dataset.topojson, monde: el.dataset.monde });
        })();
        moteur.catch(() => { moteur = null; });
      }
      return moteur;
    };
    const nomDuLien = (lien) => {
      if (lien.dataset.lciOuvrir) return lien.dataset.lciOuvrir;
      const href = lien.getAttribute('href') || '';
      const i = href.indexOf('#');
      return i < 0 ? '' : decodeURIComponent(href.slice(i + 1));
    };
    document.addEventListener('click', (e) => {
      const lien = e.target.closest('[data-lci-ouvrir], a[href*="#"]');
      if (!lien) return;
      const nom = nomDuLien(lien);
      if (!nom) return;
      for (const carte of CARTES) {
        if (carte.dataset.ancre === nom) { e.preventDefault(); carte.ouvrir(lien); return; }
      }
    });
    document.addEventListener('keydown', (e) => {
      if (e.key !== 'Escape') return;
      for (const carte of CARTES) if (carte.classList.contains('est-ouvert')) carte.fermer();
    });

    customElements.define('lucide-carte-ingredients', class extends HTMLElement {
      connectedCallback() {
        CARTES.add(this);
        this.liste = this.querySelector('.lci-liste');
        this.fiche = this.querySelector('.lci-fiche');
        this.scene = this.querySelector('.lci-scene');
        this.svg = this.querySelector('.lci-svg');
        this.anneau = this.querySelector('.lci-anneau');
        this.barre = this.querySelector('.lci-onglets');
        this.legende = this.querySelector('.lci-legende');
        this.panneau = this.querySelector('.lci-panneau');
        this.corps = this.querySelector('.lci-corps');
        this.boite = this.querySelector('.lci-carte');
        this.format = window.matchMedia('(min-width: 750px)');
        this.surClic = (e) => {
          if (e.target.closest('[data-lci-fermer]')) { this.fermer(); return; }
          const onglet = e.target.closest('.lci-onglet');
          if (onglet) { this.filtrer(onglet.dataset.g, true); return; }
          const bouton = e.target.closest('.lci-ing__bouton');
          if (bouton) {
            const item = bouton.closest('[data-lci-ing]');
            const ing = this.ings().find((x) => x.el === item);
            if (ing) { this.choisir(ing.i); this.amener(ing.i); }
          }
        };
        this.addEventListener('click', this.surClic);
        this.surDefil = () => {
          if (this.rafMini) return;
          this.rafMini = requestAnimationFrame(() => { this.rafMini = 0; this.reduire(); });
        };
        this.surToucher = () => cancelAnimationFrame(this.defile);
        this.corps.addEventListener('scroll', this.surDefil, { passive: true });
        this.corps.addEventListener('touchstart', this.surToucher, { passive: true });
        this.corps.addEventListener('wheel', this.surToucher, { passive: true });
        this.surSection = (e) => {
          if (e.detail.sectionId !== this.dataset.section) return;
          if (e.type === 'shopify:section:select') { RESTENT_OUVERTES.add(this.dataset.section); this.ouvrir(); }
          else { RESTENT_OUVERTES.delete(this.dataset.section); this.fermer(); }
        };
        this.surBloc = (e) => {
          if (e.detail.sectionId !== this.dataset.section) return;
          RESTENT_OUVERTES.add(this.dataset.section);
          const ing = this.ings().find((x) => x.el.dataset.bloc === e.detail.blockId);
          this.ouvrir(null, ing ? ing.i : undefined);
          if (ing) setTimeout(() => this.amener(ing.i), 80);
        };
        document.addEventListener('shopify:section:select', this.surSection);
        document.addEventListener('shopify:section:deselect', this.surSection);
        document.addEventListener('shopify:block:select', this.surBloc);
        this.surFormat = () => { this.reduire(); if (this.classList.contains('est-ouvert') && this.carte) this.dessiner(true); };
        this.format.addEventListener('change', this.surFormat);
        this.observateur = new ResizeObserver(() => {
          this.reduire();
          clearTimeout(this.minuterie);
          this.minuterie = setTimeout(() => { if (this.classList.contains('est-ouvert') && this.carte) this.dessiner(false); }, 180);
        });
        this.observateur.observe(this.scene);
        const hash = decodeURIComponent(location.hash.slice(1));
        if (window.Shopify && window.Shopify.designMode && RESTENT_OUVERTES.has(this.dataset.section)) {
          const memo = DERNIERS.get(this.dataset.section);
          requestAnimationFrame(() => {
            this.ouvrir(null, memo && memo.i < this.ings().length ? memo.i : undefined);
            if (memo) { this.corps.scrollTop = memo.defil; this.reduire(); }
          });
        } else if (hash && hash === this.dataset.ancre) {
          requestAnimationFrame(() => this.ouvrir());
        }
      }

      disconnectedCallback() {
        CARTES.delete(this);
        if (this.classList.contains('est-ouvert') && this.actuel !== undefined) DERNIERS.set(this.dataset.section, { i: this.actuel, defil: this.corps.scrollTop });
        document.removeEventListener('shopify:section:select', this.surSection);
        document.removeEventListener('shopify:section:deselect', this.surSection);
        document.removeEventListener('shopify:block:select', this.surBloc);
        this.format.removeEventListener('change', this.surFormat);
        this.observateur.disconnect();
        this.corps.removeEventListener('scroll', this.surDefil);
        this.corps.removeEventListener('touchstart', this.surToucher);
        this.corps.removeEventListener('wheel', this.surToucher);
        cancelAnimationFrame(this.rafMini);
        cancelAnimationFrame(this.defile);
        clearTimeout(this.attente);
        if (this.classList.contains('est-ouvert')) document.documentElement.classList.remove('lci-bloque');
        if (this.carte) this.carte.detruire();
      }

      /* les ingrédients = les blocs enfants (leurs lieux voyagent en data-attribut) */
      ings() {
        if (!this.cache) {
          this.cache = [...this.querySelectorAll('[data-lci-ing]')].map((el, i) => {
            let o = [];
            try { o = JSON.parse(el.dataset.lieux || '[]'); } catch (_) { o = []; }
            return { i, el, g: el.dataset.gamme, nom: el.dataset.nom || '', sous: el.dataset.sous || '', o, acc: getComputedStyle(el).getPropertyValue('--acc').trim() || '#3365DB' };
          });
        }
        return this.cache;
      }
      noms() {
        if (!this.nomsCache) { try { this.nomsCache = JSON.parse(this.dataset.noms || '{}'); } catch (_) { this.nomsCache = {}; } }
        return this.nomsCache;
      }

      ouvrir(declencheur, index) {
        const ings = this.ings();
        if (!ings.length) return;
        const deja = this.classList.contains('est-ouvert');
        if (!deja) {
          this.declencheur = declencheur || document.activeElement;
          this.inert = false;
          this.removeAttribute('aria-hidden');
          this.classList.add('est-ouvert');
          document.documentElement.classList.add('lci-bloque');
          this.corps.scrollTop = 0;
          requestAnimationFrame(() => this.reduire());
          this.preparerOnglets();
          setTimeout(() => { const croix = this.querySelector('.lci-fermer'); if (croix) croix.focus({ preventScroll: true }); }, 60);
        }
        const depart = Math.min(Math.max(1, parseInt(this.dataset.depart, 10) || 1), ings.length) - 1;
        const i = index !== undefined ? index : (deja && this.actuel !== undefined ? this.actuel : depart);
        this.marquer(i);
        this.lancer(i, deja);
      }

      async lancer(i, deja) {
        this.classList.remove('est-en-erreur');
        if (!this.monde) this.classList.add('est-en-chargement');
        try {
          this.monde = await preparerMoteur(this);
          this.classList.remove('est-en-chargement');
          if (!this.classList.contains('est-ouvert')) return;
          this.dessiner(false);
          this.carte.visible = true;
          if (!deja && this.carte.reinitialiser) this.carte.reinitialiser();
          clearTimeout(this.attente);
          const delai = deja ? 0 : (this.mode === 'tel' ? 650 : 350);
          this.attente = setTimeout(() => this.choisir(i), calme() ? 0 : delai);
        } catch (err) {
          this.classList.remove('est-en-chargement');
          this.classList.add('est-en-erreur');
          console.error('Carte des ingrédients :', err);
        }
      }

      fermer() {
        if (!this.classList.contains('est-ouvert')) return;
        this.classList.remove('est-ouvert');
        this.setAttribute('aria-hidden', 'true');
        this.inert = true;
        document.documentElement.classList.remove('lci-bloque');
        clearTimeout(this.attente);
        const retour = this.declencheur;
        this.declencheur = null;
        if (retour && retour.focus && document.contains(retour)) retour.focus({ preventScroll: true });
        setTimeout(() => {
          if (this.classList.contains('est-ouvert') || !this.carte) return;
          if (this.carte.reinitialiser) this.carte.reinitialiser();
          this.carte.visible = false;
        }, 520);
      }

      /* crée le dessin du format en cours (Atlas sur ordinateur, Globe sur téléphone) */
      dessiner(force) {
        const LC = window.LucideCarte;
        if (!LC || !this.monde) return;
        const mode = this.format.matches ? 'ordi' : 'tel';
        const w = Math.round(this.scene.clientWidth), h = Math.round(this.scene.clientHeight);
        if (!w || !h) return;
        if (!force && this.carte && this.mode === mode && this.dims === w + 'x' + h) return;
        const refaire = !!this.carte;
        if (this.carte) this.carte.detruire();
        this.mode = mode;
        this.dims = w + 'x' + h;
        const d = this.dataset, ings = this.ings();
        const commun = {
          w, h, uid: d.section, monde: this.monde,
          fr: { n: d.fabNom || '', c: [nombre(d.fabLon, -0.55), nombre(d.fabLat, 47.47)] },
          duree: calme() ? 0 : nombre(d.duree, 800),
          recul: calme() ? 0 : nombre(d.recul, 30) / 100
        };
        if (mode === 'ordi') {
          this.carte = new LC.Atlas(this.svg, Object.assign(commun, { points: [commun.fr.c, ...LC.points(ings)], kMax: nombre(d.zoomCarte, 320) / 100, marge: 70 }));
        } else {
          const zoom = nombre(d.zoomGlobe, 120) / 100;
          const rayon = Math.max(60, Math.min(nombre(d.globe, 280) / 2 - 3, (w / 2 - 8) / zoom, (h / 2 - 4) / zoom));
          this.anneau.style.width = this.anneau.style.height = (2 * rayon + 6) + 'px';
          this.carte = new LC.Globe(this.svg, Object.assign(commun, { r: rayon, zoom, anneau: this.anneau, rotation: d.rotation === 'true' && !calme() }));
        }
        this.remplirLegende(ings);
        if (refaire && this.actuel !== undefined) {
          if (mode === 'ordi' && this.carte.reserver) this.carte.reserver(this.fiche.offsetHeight + 18);
          this.carte.montrer(this.versCarte(ings[this.actuel]), true);
        }
      }

      versCarte(ing) { return { acc: ing.acc, o: ing.o }; }

      marquer(i) {
        const ings = this.ings(), ing = ings[i];
        if (!ing) return;
        this.actuel = i;
        if (this.filtre && this.filtre !== 'tout' && ing.g !== this.filtre) this.filtrer(ing.g, false);
        for (const x of ings) {
          const on = x.i === i;
          x.el.classList.toggle('est-actif', on);
          const bouton = x.el.querySelector('.lci-ing__bouton');
          if (bouton) bouton.setAttribute('aria-expanded', on ? 'true' : 'false');
        }
        this.remplirFiche(ing);
        if (this.dataset.auraGamme === 'true') this.style.setProperty('--lci-aura-c', ing.acc);
      }

      choisir(i) {
        const ing = this.ings()[i];
        if (!ing) return;
        this.marquer(i);
        if (!this.carte) return;
        if (this.mode === 'ordi' && this.carte.reserver) this.carte.reserver(this.fiche.offsetHeight + 18);
        this.carte.montrer(this.versCarte(ing));
      }

      /* téléphone, globe collant : la part réduite du globe (réglage « taille du globe réduit ») */
      mini() { return Math.min(0.95, Math.max(0.3, nombre(this.dataset.mini, 55) / 100)); }
      collant() { return this.classList.contains('lci--collant') && !this.format.matches; }

      /* quand on descend, le globe rétrécit d'autant qu'il remonte : il reste entier, en haut */
      reduire() {
        if (!this.boite) return;
        if (!this.collant()) { this.scene.style.transform = ''; this.scene.style.removeProperty('--lci-etq-o'); return; }
        const m = this.mini(), d = this.scene.offsetHeight * (1 - m);
        const p = d > 0 ? Math.min(1, Math.max(0, this.corps.scrollTop / d)) : 0;
        const k = 1 - (1 - m) * p;
        this.scene.style.transform = p > 0 ? 'scale(' + k.toFixed(4) + ')' : '';
        /* les étiquettes s'effacent quand le globe devient trop petit pour les lire */
        this.scene.style.setProperty('--lci-etq-o', Math.min(1, Math.max(0, (k - 0.62) / 0.2)).toFixed(2));
        const pr = this.panneau.getBoundingClientRect(), br = this.boite.getBoundingClientRect();
        const s = this.boite.style;
        s.setProperty('--lci-mini-p', p.toFixed(3));
        s.setProperty('--lci-off', (br.top - pr.top).toFixed(1) + 'px');
        s.setProperty('--lci-boite', br.height.toFixed(1) + 'px');
        s.setProperty('--lci-pan-w', pr.width.toFixed(1) + 'px');
        s.setProperty('--lci-pan-h', pr.height.toFixed(1) + 'px');
      }

      /* l'ingrédient touché vient se placer juste sous le globe réduit (il suit la liste qui se replie) */
      amener(i) {
        const ing = this.ings()[i];
        if (!ing || !this.collant() || !this.classList.contains('est-ouvert')) return;
        cancelAnimationFrame(this.defile);
        const debut = performance.now();
        const pas = () => {
          const haut = this.boite.offsetHeight - this.scene.offsetHeight * (1 - this.mini());
          const cible = this.corps.getBoundingClientRect().top + haut + 6;
          const max = this.corps.scrollHeight - this.corps.clientHeight;
          const vise = Math.max(0, Math.min(max, this.corps.scrollTop + ing.el.getBoundingClientRect().top - cible));
          const ecart = vise - this.corps.scrollTop, t = performance.now() - debut;
          this.corps.scrollTop += calme() || Math.abs(ecart) < 1 ? ecart : Math.sign(ecart) * Math.max(1, Math.abs(ecart) * 0.2);
          if (t < 1500 && (t < 500 || Math.abs(ecart) >= 1)) this.defile = requestAnimationFrame(pas);
        };
        this.defile = requestAnimationFrame(pas);
      }

      remplirFiche(ing) {
        if (!this.fiche) return;
        const detail = ing.el.querySelector('.lci-ing__detail-in');
        this.fiche.style.setProperty('--acc', ing.acc);
        this.fiche.innerHTML = '<div class="lci-fiche__gamme"><i></i>' + echapper(this.noms()[ing.g] || '') + '</div>'
          + '<h3 class="lci-fiche__nom">' + echapper(ing.nom) + (ing.sous ? '<small>' + echapper(ing.sous) + '</small>' : '') + '</h3>'
          + (detail ? detail.innerHTML : '');
        this.fiche.classList.remove('change');
        void this.fiche.offsetWidth;
        this.fiche.classList.add('change');
      }

      remplirLegende(ings) {
        if (!this.legende) return;
        const noms = this.noms(), ordre = ['deep_focus', 'booster_pro', 'deep_night'];
        const gammes = ordre.filter((g) => ings.some((x) => x.g === g));
        this.legende.innerHTML = gammes.map((g) => '<span><i style="background:' + ings.find((x) => x.g === g).acc + '"></i>' + echapper(noms[g] || '') + '</span>').join('')
          + (this.dataset.fabNom ? '<span><i class="carre"></i>' + echapper(this.dataset.fabNom) + '</span>' : '');
      }

      /* onglets de gamme : seulement si le réglage est coché et qu'il y a au moins deux gammes */
      preparerOnglets() {
        if (this.ongletsPrets) return;
        this.ongletsPrets = true;
        const ings = this.ings(), noms = this.noms(), ordre = ['deep_focus', 'booster_pro', 'deep_night'];
        const gammes = ordre.filter((g) => ings.some((x) => x.g === g));
        if (this.dataset.onglets !== 'true' || gammes.length < 2) { this.filtre = 'tout'; return; }
        const tout = this.dataset.tout ? '<button type="button" class="lci-onglet" role="tab" data-g="tout">' + echapper(this.dataset.tout) + '</button>' : '';
        this.barre.innerHTML = tout + gammes.map((g) => '<button type="button" class="lci-onglet" role="tab" data-g="' + g + '" style="--acc:' + ings.find((x) => x.g === g).acc + '"><i></i>' + echapper(noms[g] || g) + '</button>').join('');
        this.barre.hidden = false;
        const depart = ings[Math.min(Math.max(1, parseInt(this.dataset.depart, 10) || 1), ings.length) - 1];
        this.filtrer(this.format.matches && this.dataset.tout ? 'tout' : depart.g, false);
      }

      filtrer(g, depuisClic) {
        if (this.barre.hidden) return;
        const ings = this.ings();
        if (g === 'tout' && (!this.format.matches || !this.dataset.tout)) g = (ings[this.actuel !== undefined ? this.actuel : 0] || ings[0]).g;
        this.filtre = g;
        for (const b of this.barre.querySelectorAll('.lci-onglet')) {
          const on = b.dataset.g === g;
          b.classList.toggle('est-actif', on);
          b.setAttribute('aria-selected', on ? 'true' : 'false');
        }
        for (const x of ings) x.el.hidden = !(g === 'tout' || x.g === g);
        if (depuisClic) {
          const visible = ings.filter((x) => !x.el.hidden);
          if (visible.length && (this.actuel === undefined || ings[this.actuel].el.hidden)) this.choisir(visible[0].i);
        }
      }
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["lucide-chiffres-geants"] && !Shopify.designMode) return;
  try {
    
  (function () {
    /* Le chiffre compte jusqu'à sa valeur : « 83,5 % », « −44 % », « +46 kg », « 28 jours ».
       Le texte saisi est découpé en avant / nombre / après ; rien d'autre n'est touché. */
    function compter(el) {
      var brut = el.getAttribute('data-lcg-final') || el.textContent;
      el.setAttribute('data-lcg-final', brut);
      var m = brut.match(/^([\s\S]*?)(\d+(?:[.,]\d+)?)([\s\S]*)$/);
      if (!m) return;
      var avant = m[1];
      var nombre = m[2];
      var apres = m[3];
      var sep = nombre.indexOf(',') > -1 ? ',' : '.';
      var dec = nombre.indexOf(sep) > -1 ? nombre.split(sep)[1].length : 0;
      var cible = parseFloat(nombre.replace(',', '.'));
      var duree = 1100;
      var debut = null;
      /* un nouveau comptage (retour sur la section) annule celui qui tournait encore */
      var tour = (el._lcgTour || 0) + 1;
      el._lcgTour = tour;
      function ecrire(v) {
        el.textContent = avant + v.toFixed(dec).replace('.', sep) + apres;
      }
      function image(t) {
        if (el._lcgTour !== tour) return;
        if (debut === null) debut = t;
        var p = Math.min((t - debut) / duree, 1);
        ecrire(cible * (1 - Math.pow(1 - p, 3)));
        if (p < 1) requestAnimationFrame(image);
      }
      ecrire(0);
      requestAnimationFrame(image);
      setTimeout(function () {
        if (el._lcgTour === tour) el.textContent = brut;
      }, duree + 150);
    }

    if (!customElements.get('lucide-chiffres-geants')) {
      customElements.define(
        'lucide-chiffres-geants',
        class extends HTMLElement {
          connectedCallback() {
            var self = this;
            var lignes = Array.prototype.slice.call(this.querySelectorAll('[data-lcg-ligne]'));
            var calme = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
            /* Éditeur : chiffres fixes, tout affiché (on règle sans attendre). Plus de filet à 2,5 s : il
               lançait le comptage hors de l'écran, le client arrivait sur des chiffres déjà finis (Omar 09/10). */
            var editeur = window.Shopify && window.Shopify.designMode;
            if (this.getAttribute('data-compter') !== 'true' || calme || editeur || !('IntersectionObserver' in window)) return;
            this.classList.add('lcg--anime');
            function montrer(ligne) {
              if (ligne.classList.contains('est-vue')) return;
              ligne.classList.add('est-vue');
              var n = ligne.querySelector('[data-lcg-compte]');
              if (n) compter(n);
            }
            function cacher(ligne) {
              if (!ligne.classList.contains('est-vue')) return;
              ligne.classList.remove('est-vue');
              var n = ligne.querySelector('[data-lcg-compte]');
              if (n) {
                n._lcgTour = (n._lcgTour || 0) + 1;
                if (n.getAttribute('data-lcg-final')) n.textContent = n.getAttribute('data-lcg-final');
              }
            }
            /* Compte quand la ligne est visible au tiers ; se réarme quand elle est sortie de l'écran,
               pour recompter à chaque retour sur la section. */
            this._obs = new IntersectionObserver(
              function (entrees) {
                entrees.forEach(function (x) {
                  if (x.intersectionRatio >= 0.3) montrer(x.target);
                  else if (!x.isIntersecting) cacher(x.target);
                });
              },
              { threshold: [0, 0.3] }
            );
            lignes.forEach(function (l) {
              self._obs.observe(l);
            });
          }
          disconnectedCallback() {
            if (this._obs) this._obs.disconnect();
          }
        }
      );
    }

    /* Bouton vers une ancre LUCIDE (onglet SCIENCE de la FAQ) : même mécanisme que le bloc
       Cliniciens ; sort si un autre script a déjà fait le trajet (defaultPrevented). */
    if (!window.__lucideAncreChiffresGeants) {
      window.__lucideAncreChiffresGeants = true;
      document.addEventListener('click', function (e) {
        var lien = e.target.closest && e.target.closest('.lcg__btn[data-lcg-ancre]');
        if (!lien || e.defaultPrevented) return;
        var id = (lien.getAttribute('href') || '').slice(1);
        var cible = id && document.getElementById(id);
        if (!cible) return;
        e.preventDefault();
        document.dispatchEvent(new CustomEvent('lucide:reveler', { detail: cible }));
        var pliage = cible.closest('details');
        if (pliage) pliage.open = true;
        var douceur = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth';
        cible.scrollIntoView({ behavior: douceur, block: 'start' });
      });
    }
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["lucide-chiffres-produit"] && !Shopify.designMode) return;
  try {
    
  (function () {
    if (window.lucideChiffresProduitInit) return;
    window.lucideChiffresProduitInit = true;

    function jouer(nombres, duree) {
      var cibles = nombres.map(function (n) {
        return parseInt(n.getAttribute('data-cible'), 10);
      });
      nombres.forEach(function (n) { n.textContent = '0'; });

      var depart = Date.now();
      var minuteur = setInterval(function () {
        var p = (Date.now() - depart) / (duree * 1000);
        if (p > 1) p = 1;
        var e = 1 - Math.pow(1 - p, 3);
        nombres.forEach(function (n, i) {
          n.textContent = String(Math.round(cibles[i] * e));
        });
        if (p >= 1) {
          clearInterval(minuteur);
          nombres.forEach(function (n) {
            n.textContent = n.getAttribute('data-cible');
          });
        }
      }, 30);
    }

    function initialiser(racine) {
      if (racine.dataset.lucidePret) return;
      racine.dataset.lucidePret = '1';

      if (racine.getAttribute('data-anim') !== 'true') return;
      if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;

      var nombres = Array.prototype.slice
        .call(racine.querySelectorAll('[data-lucide-nombre]'))
        .filter(function (n) {
          return /^[0-9]+$/.test(n.getAttribute('data-cible') || '');
        });
      if (!nombres.length) return;

      var duree = parseFloat(racine.getAttribute('data-duree')) || 1.5;

      var observateur = new IntersectionObserver(function (entrees) {
        entrees.forEach(function (entree) {
          if (!entree.isIntersecting) return;
          observateur.disconnect();
          jouer(nombres, duree);
        });
      }, { threshold: 0.3 });
      observateur.observe(racine);
    }

    function tout() {
      document.querySelectorAll('[data-lucide-chiffres-produit]').forEach(initialiser);
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', tout);
    } else {
      tout();
    }

    document.addEventListener('shopify:section:load', function () {
      document.querySelectorAll('[data-lucide-chiffres-produit]').forEach(function (r) {
        delete r.dataset.lucidePret;
      });
      tout();
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["lucide-chronologie"] && !Shopify.designMode) return;
  try {
    
  (function () {
    if (window.lucideChronoInit) return;
    window.lucideChronoInit = true;

    function initialiser(racine) {
      if (racine.dataset.lucidePret) return;
      racine.dataset.lucidePret = '1';

      var slides = racine.querySelector('[data-lucide-slides]');
      var mois = Array.prototype.slice.call(racine.querySelectorAll('[data-lucide-mois]'));
      var allers = Array.prototype.slice.call(racine.querySelectorAll('[data-lucide-va]'));
      if (!slides || !mois.length) return;

      /* Les réglages des blocs sont invisibles depuis la section : on récupère titre
         et image directement dans le rendu de chaque mois. */
      var onglets = Array.prototype.slice.call(racine.querySelectorAll('.lucide-chrono__onglet'));
      var figures = Array.prototype.slice.call(slides.children);
      mois.forEach(function (m, i) {
        var titre = m.querySelector('.lucide-mois__titre');
        if (onglets[i] && titre) onglets[i].textContent = titre.textContent;
        var img = m.querySelector('.lucide-mois__media img');
        if (img && figures[i]) {
          figures[i].innerHTML = '';
          figures[i].appendChild(img.cloneNode(true));
        }
      });

      var minuteur = null;
      var avance = parseFloat(racine.getAttribute('data-avance')) || 0;
      var reduit = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

      function activer(i) {
        mois.forEach(function (m, k) {
          if (k === i) { m.setAttribute('data-actif', ''); } else { m.removeAttribute('data-actif'); }
        });
        allers.forEach(function (b) {
          if (parseInt(b.getAttribute('data-lucide-va'), 10) === i) { b.setAttribute('data-actif', ''); } else { b.removeAttribute('data-actif'); }
        });
      }

      function glisser(i, doux) {
        slides.scrollTo({ left: i * slides.clientWidth, behavior: doux ? 'smooth' : 'instant' });
        activer(i);
      }

      function indexCourant() {
        return Math.max(0, Math.min(mois.length - 1, Math.round(slides.scrollLeft / slides.clientWidth)));
      }

      var attente = null;
      slides.addEventListener('scroll', function () {
        if (attente) clearTimeout(attente);
        attente = setTimeout(function () {
          attente = null;
          activer(indexCourant());
        }, 80);
      });

      racine.addEventListener('click', function (e) {
        var cible = e.target.closest('[data-lucide-va]');
        if (cible && racine.contains(cible)) {
          arreter();
          glisser(parseInt(cible.getAttribute('data-lucide-va'), 10), true);
          return;
        }
        var m = e.target.closest('[data-lucide-mois]');
        if (m) {
          arreter();
          glisser(mois.indexOf(m), true);
        }
      });

      function arreter() {
        if (minuteur) { clearInterval(minuteur); minuteur = null; }
      }

      if (avance > 0 && !reduit && mois.length > 1) {
        minuteur = setInterval(function () {
          glisser((indexCourant() + 1) % mois.length, true);
        }, avance * 1000);
        slides.addEventListener('pointerdown', arreter);
        racine.addEventListener('pointerenter', function () { if (minuteur) { clearInterval(minuteur); minuteur = null; racine.dataset.lucidePause = '1'; } });
        racine.addEventListener('pointerleave', function () {
          if (racine.dataset.lucidePause && avance > 0) {
            delete racine.dataset.lucidePause;
            minuteur = setInterval(function () { glisser((indexCourant() + 1) % mois.length, true); }, avance * 1000);
          }
        });
      }

      activer(0);
    }

    function tout() {
      document.querySelectorAll('[data-lucide-chrono]').forEach(initialiser);
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', tout);
    } else {
      tout();
    }

    document.addEventListener('shopify:section:load', function () {
      document.querySelectorAll('[data-lucide-chrono]').forEach(function (r) { delete r.dataset.lucidePret; });
      tout();
    });

    /* Dans l'éditeur : sélectionner un bloc « Mois » l'active à l'écran */
    document.addEventListener('shopify:block:select', function (e) {
      var m = e.target && e.target.closest ? (e.target.matches('[data-lucide-mois]') ? e.target : e.target.querySelector('[data-lucide-mois]')) : null;
      if (!m) return;
      var racine = m.closest('[data-lucide-chrono]');
      if (!racine) return;
      var mois = Array.prototype.slice.call(racine.querySelectorAll('[data-lucide-mois]'));
      var slides = racine.querySelector('[data-lucide-slides]');
      var i = mois.indexOf(m);
      if (i < 0 || !slides) return;
      mois.forEach(function (x, k) { if (k === i) { x.setAttribute('data-actif', ''); } else { x.removeAttribute('data-actif'); } });
      racine.querySelectorAll('[data-lucide-va]').forEach(function (b) {
        if (parseInt(b.getAttribute('data-lucide-va'), 10) === i) { b.setAttribute('data-actif', ''); } else { b.removeAttribute('data-actif'); }
      });
      slides.scrollTo({ left: i * slides.clientWidth, behavior: 'smooth' });
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["lucide-courbe-cure"] && !Shopify.designMode) return;
  try {
    
  (() => {
    if (customElements.get('lucide-courbe-cure')) return;

    /* Le JS de Magna : chaque point se pose sur la courbe au-dessus de son étape (recherche du
       x sur le tracé), et la progression suit le défilement de la page (écouté en capture :
       attrape aussi le défilement de .page-wrapper). */
    class LucideCourbeCure extends HTMLElement {
      connectedCallback() {
        this.etapes = [...this.querySelectorAll('.lcc__etape')];
        this.liste = this.querySelector('.lcc__etapes');
        this.svg = this.querySelector('.lcc__courbe');
        this.trait = this.querySelector('.lcc__ligne');
        this.base = this.querySelector('.lcc__base');
        this.ordi = window.matchMedia('(min-width: 750px)');
        const calme = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
        this.anime = !calme && !(window.Shopify && window.Shopify.designMode);
        if (this.anime) this.classList.add('lcc--anime');
        this.minuteur = null;
        this.demander = () => {
          if (this.minuteur) return;
          this.minuteur = setTimeout(() => {
            this.minuteur = null;
            this.maj();
          }, 16);
        };
        this.surTaille = () => {
          this.placer();
          this.maj();
        };
        document.addEventListener('scroll', this.demander, { capture: true, passive: true });
        window.addEventListener('resize', this.surTaille);
        this.observateur = new ResizeObserver(this.surTaille);
        this.observateur.observe(this);
        if (document.fonts) document.fonts.ready.then(this.surTaille);
        this.surTaille();
      }

      disconnectedCallback() {
        document.removeEventListener('scroll', this.demander, { capture: true });
        window.removeEventListener('resize', this.surTaille);
        if (this.observateur) this.observateur.disconnect();
        clearTimeout(this.minuteur);
      }

      placer() {
        const n = this.etapes.length;
        if (!this.ordi.matches || !this.trait) {
          let i = 0;
          for (const el of this.etapes) {
            el.dataset.seuil = (0.32 + (i * 0.52) / Math.max(1, n - 1)).toFixed(3);
            i += 1;
          }
          return;
        }
        const longueur = this.trait.getTotalLength();
        const vb = this.svg.viewBox.baseVal;
        const rs = this.svg.getBoundingClientRect();
        const yBase = this.base.getBoundingClientRect().top;
        if (!rs.width) return;
        for (const el of this.etapes) {
          const x = ((el.getBoundingClientRect().left - rs.left) / rs.width) * vb.width;
          let bas = 0;
          let haut = longueur;
          for (let k = 0; k < 18; k += 1) {
            const milieu = (bas + haut) / 2;
            if (this.trait.getPointAtLength(milieu).x < x) bas = milieu;
            else haut = milieu;
          }
          const point = this.trait.getPointAtLength((bas + haut) / 2);
          const yCourbe = rs.top + (point.y / vb.height) * rs.height;
          el.style.setProperty('--lcc-y', `${Math.max(0, yBase - yCourbe).toFixed(1)}px`);
          el.dataset.seuil = ((bas + haut) / 2 / longueur).toFixed(3);
        }
      }

      maj() {
        if (!this.anime) return;
        const vh = window.innerHeight || document.documentElement.clientHeight;
        if (!this.ordi.matches) {
          /* Téléphone (patron de l'ancienne frise) : ligne de déclenchement au milieu de l'écran ; le trait se
             remplit jusqu'à elle, chaque étape s'allume quand le centre de son point la franchit. */
          const ligne = vh * 0.5;
          const boite = this.liste.getBoundingClientRect();
          const debut = boite.top + (parseFloat(getComputedStyle(this.liste, '::after').top) || 23);
          const part = (ligne - debut) / Math.max(1, boite.bottom - debut);
          this.style.setProperty('--lcc-rail', Math.max(0, Math.min(1, part)).toFixed(3));
          for (const el of this.etapes) {
            const point = el.querySelector('.lcc__point').getBoundingClientRect();
            el.classList.remove('est-visible');
            el.classList.toggle('est-active', point.top + point.height / 2 <= ligne);
          }
          return;
        }
        const y = this.getBoundingClientRect().top;
        const p = Math.max(0, Math.min(1, (vh * 0.86 - y) / (vh * 0.78)));
        this.style.setProperty('--lcc-prog', p.toFixed(3));
        for (const el of this.etapes) {
          el.classList.remove('est-active');
          el.classList.toggle('est-visible', p >= Number(el.dataset.seuil));
        }
      }
    }

    customElements.define('lucide-courbe-cure', LucideCourbeCure);
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["lucide-courbe-etapes"] && !Shopify.designMode) return;
  try {
    
  (function () {
    if (window.lucideCeInit) return;
    window.lucideCeInit = true;

    var NS = 'http://www.w3.org/2000/svg';

    function el(nom, attrs) {
      var e = document.createElementNS(NS, nom);
      for (var k in attrs) e.setAttribute(k, attrs[k]);
      return e;
    }

    function lireConfig(racine) {
      var min = parseFloat(racine.dataset.valMin);
      var max = parseFloat(racine.dataset.valMax);
      var pas = parseFloat(racine.dataset.pas);
      var semaines = parseInt(racine.dataset.semaines, 10);
      if (!isFinite(min)) min = 0;
      if (!isFinite(max) || max <= min) max = min + 100;
      if (!isFinite(pas) || pas <= 0) pas = (max - min) / 4;
      if (!isFinite(semaines) || semaines < 2) semaines = 12;
      return { min: min, max: max, pas: pas, semaines: semaines, libY: racine.dataset.libelleY || '', libX: racine.dataset.libelleX || '' };
    }

    function lirePoints(etape) {
      var brut = etape.querySelector('[data-lucide-ce-points]');
      if (!brut) return [];
      return brut.textContent.split(',').map(function (morceau) {
        var duo = morceau.split(':');
        return { s: parseFloat(duo[0]), v: parseFloat(duo[1]) };
      }).filter(function (p) { return isFinite(p.s) && isFinite(p.v); });
    }

    function construireGraphe(fig, pts, cfg) {
      fig.innerHTML = '';
      var L = 640, H = 400, m = { g: 64, d: 16, h: 16, b: 46 };
      function x(s) { return m.g + ((s - 1) / (cfg.semaines - 1)) * (L - m.g - m.d); }
      function y(v) { return (H - m.b) - ((v - cfg.min) / (cfg.max - cfg.min)) * (H - m.b - m.h); }

      if (cfg.libY) {
        var ay = document.createElement('span');
        ay.className = 'lucide-ce__axe-y';
        ay.textContent = cfg.libY;
        fig.appendChild(ay);
      }
      var svg = el('svg', { viewBox: '0 0 ' + L + ' ' + H, class: 'lucide-ce__svg', 'aria-hidden': 'true' });

      for (var v = cfg.min; v <= cfg.max + 0.001; v += cfg.pas) {
        svg.appendChild(el('line', { class: 'lucide-ce__ligne-grille', x1: m.g, x2: L - m.d, y1: y(v), y2: y(v) }));
        var ty = el('text', { x: m.g - 12, y: y(v) + 5, 'text-anchor': 'end' });
        ty.textContent = Math.round(v);
        svg.appendChild(ty);
      }
      svg.appendChild(el('path', { class: 'lucide-ce__axes', d: 'M' + m.g + ',' + m.h + ' V' + (H - m.b) + ' H' + (L - m.d) }));
      for (var s = 1; s <= cfg.semaines; s++) {
        var tx = el('text', { x: x(s), y: H - m.b + 26, 'text-anchor': 'middle' });
        tx.textContent = s;
        svg.appendChild(tx);
      }

      var visibles = pts.filter(function (p) { return p.s >= 1 && p.s <= cfg.semaines; });
      if (visibles.length) {
        var coords = visibles.map(function (p) { return x(p.s) + ',' + y(p.v); }).join(' ');
        var courbe = el('polyline', { class: 'lucide-ce__courbe', points: coords });
        courbe.setAttribute('pathLength', '1');
        svg.appendChild(courbe);
        visibles.forEach(function (p, i) {
          var rond = el('circle', { class: 'lucide-ce__point', cx: x(p.s), cy: y(p.v), r: 6.5 });
          rond.style.animationDelay = (0.15 + (i / visibles.length) * 0.85).toFixed(2) + 's';
          svg.appendChild(rond);
        });
      }
      fig.appendChild(svg);

      if (cfg.libX) {
        var ax = document.createElement('span');
        ax.className = 'lucide-ce__axe-x';
        ax.textContent = cfg.libX;
        fig.appendChild(ax);
      }
    }

    function lesEtapes(racine) {
      return Array.prototype.slice.call(racine.querySelectorAll('[data-lucide-ce-etape]'));
    }

    function activer(racine, k) {
      var boutons = racine.querySelectorAll('.lucide-ce__onglet');
      lesEtapes(racine).forEach(function (etape, i) {
        etape.classList.toggle('est-active', i === k);
        if (boutons[i]) boutons[i].classList.toggle('est-actif', i === k);
      });
    }

    function initialiser(racine) {
      if (racine.dataset.lucideCePret) return;
      var onglets = racine.querySelector('[data-lucide-ce-onglets]');
      var etapes = lesEtapes(racine);
      if (!onglets || !etapes.length) return;
      racine.dataset.lucideCePret = '1';
      var cfg = lireConfig(racine);
      var cumul = [];
      onglets.innerHTML = '';
      etapes.forEach(function (etape, k) {
        var libelle = etape.querySelector('[data-lucide-ce-libelle]');
        var bouton = document.createElement('button');
        bouton.type = 'button';
        bouton.className = 'lucide-ce__onglet';
        bouton.setAttribute('data-lucide-ce-onglet', k);
        bouton.textContent = libelle ? libelle.textContent.trim() : 'Étape ' + (k + 1);
        onglets.appendChild(bouton);
        cumul = cumul.concat(lirePoints(etape));
        var fig = etape.querySelector('[data-lucide-ce-graphe]');
        if (fig) construireGraphe(fig, cumul.slice(), cfg);
      });
      activer(racine, 0);
    }

    function tout() {
      Array.prototype.forEach.call(document.querySelectorAll('[data-lucide-ce]'), initialiser);
    }

    document.addEventListener('click', function (e) {
      var bouton = e.target.closest('[data-lucide-ce-onglet]');
      if (!bouton) return;
      activer(bouton.closest('[data-lucide-ce]'), parseInt(bouton.getAttribute('data-lucide-ce-onglet'), 10));
    });

    /* Éditeur : sélectionner un bloc étape affiche son onglet ; re-rendu = réinitialiser */
    document.addEventListener('shopify:block:select', function (e) {
      var etape = e.target.querySelector ? (e.target.matches('[data-lucide-ce-etape]') ? e.target : e.target.querySelector('[data-lucide-ce-etape]')) : null;
      if (!etape) return;
      var racine = etape.closest('[data-lucide-ce]');
      if (racine) activer(racine, lesEtapes(racine).indexOf(etape));
    });
    document.addEventListener('shopify:section:load', tout);

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', tout);
    } else {
      tout();
    }
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["lucide-experts"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('lucide-experts')) {
    customElements.define(
      'lucide-experts',
      class extends HTMLElement {
        connectedCallback() {
          const zoneOnglets = this.querySelector('[data-lexs-onglets]');
          const zonePhoto = this.querySelector('[data-lexs-photo]');
          const zoneContenu = this.querySelector('[data-lexs-contenu]');
          const zoneBas = this.querySelector('[data-lexs-bas]');
          if (!zoneOnglets || !zonePhoto || !zoneContenu) return;

          /* 1. Tout bloc de thème qui n'est pas un onglet descend sous la carte */
          Array.from(zoneOnglets.children).forEach((enfant) => {
            const estOnglet = enfant.classList.contains('lexs__personne') || enfant.querySelector('.lexs__personne');
            if (!estOnglet && zoneBas) zoneBas.appendChild(enfant);
          });

          /* 2. Les experts : photo et contenu déplacés vers leurs zones */
          this.personnes = Array.from(this.querySelectorAll('.lexs__personne'));
          this.photos = [];
          this.contenus = [];
          this.onglets = [];
          const survol = this.dataset.survol === 'true';
          this.personnes.forEach((p, i) => {
            const photo = p.querySelector('.lexs__photo-boite');
            const contenu = p.querySelector('.lexs__contenu');
            const onglet = p.querySelector('.lexs__onglet');
            if (photo) { zonePhoto.appendChild(photo); this.photos[i] = photo; }
            if (contenu) { zoneContenu.appendChild(contenu); this.contenus[i] = contenu; }
            if (onglet) {
              this.onglets[i] = onglet;
              onglet.addEventListener('click', () => this.montrer(i));
              if (survol) onglet.addEventListener('pointerenter', () => this.montrer(i));
            }
          });
          this.classList.add('lexs--prete');
          if (this.personnes.length) this.montrer(0);

          this.addEventListener('shopify:block:select', (e) => {
            const p = e.target && e.target.closest ? e.target.closest('.lexs__personne') : null;
            const i = this.personnes.indexOf(p);
            if (i >= 0) this.montrer(i);
          });
        }

        montrer(i) {
          this.photos.forEach((el, j) => { if (el) el.toggleAttribute('hidden', j !== i); });
          this.contenus.forEach((el, j) => { if (el) el.toggleAttribute('hidden', j !== i); });
          this.onglets.forEach((el, j) => { if (el) el.setAttribute('aria-selected', j === i ? 'true' : 'false'); });
        }
      }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["lucide-faq-image"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('lucide-faq-groupe')) {
    customElements.define(
      'lucide-faq-groupe',
      class LucideFaqGroupe extends HTMLElement {
        connectedCallback() {
          if (!this.hasAttribute('exclusif')) return;

          const lignes = this.querySelectorAll('details');
          if (lignes.length === 0) return;

          if (!this.groupName) {
            this.groupName = 'faq-' + Math.random().toString(36).slice(2, 10);
          }

          let ouverte = null;
          lignes.forEach((ligne) => {
            if (!ligne.open) return;
            if (ouverte) {
              ligne.open = false;
            } else {
              ouverte = ligne;
            }
          });

          lignes.forEach((ligne) => {
            ligne.setAttribute('name', this.groupName);
          });
        }
      }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["lucide-faq-onglets"] && !Shopify.designMode) return;
  try {
    
  /* Fabrique les boutons d'onglets à partir des groupes (data-lfao-nom), montre le premier,
     cache les autres. Flèches gauche/droite au clavier. Dans l'éditeur, sélectionner un
     groupe ou une question affiche son onglet. */
  if (!customElements.get('lucide-faq-onglets')) {
    customElements.define('lucide-faq-onglets', class extends HTMLElement {
      connectedCallback() {
        this.construire();
        this.surSelection = (e) => {
          const groupe = e.target && e.target.closest ? e.target.closest('[data-lfao-groupe]') : null;
          if (groupe && this.contains(groupe)) { this.construire(); this.activer(this.groupes().indexOf(groupe)); }
        };
        document.addEventListener('shopify:block:select', this.surSelection);
        /* une ancre visée (#ancre-…, bouton « Voir toutes les études ») ouvre son onglet AVANT le défilement */
        this.surReveler = (e) => {
          const cible = e.detail;
          if (!cible || !cible.closest || !this.contains(cible)) return;
          const groupe = cible.closest('[data-lfao-groupe]');
          if (groupe) this.activer(this.groupes().indexOf(groupe));
        };
        document.addEventListener('lucide:reveler', this.surReveler);
        let visee = '';
        try { visee = decodeURIComponent(location.hash.slice(1)); } catch (_) { visee = ''; }
        const cible = visee && document.getElementById(visee);
        if (cible && this.contains(cible)) this.surReveler({ detail: cible });
      }
      disconnectedCallback() {
        document.removeEventListener('shopify:block:select', this.surSelection);
        document.removeEventListener('lucide:reveler', this.surReveler);
      }
      groupes() { return Array.prototype.slice.call(this.querySelectorAll('[data-lfao-groupe]')); }
      construire() {
        const nav = this.querySelector('[data-lfao-nav]');
        const groupes = this.groupes();
        if (!nav) return;
        nav.innerHTML = '';
        if (groupes.length < 2) {
          nav.hidden = true;
          this.classList.remove('lfao--pret');
          groupes.forEach((g) => { g.hidden = false; });
          return;
        }
        groupes.forEach((g, i) => {
          const b = document.createElement('button');
          b.type = 'button';
          b.className = 'lfao__onglet';
          b.setAttribute('role', 'tab');
          b.textContent = g.getAttribute('data-lfao-nom') || 'Onglet ' + (i + 1);
          b.addEventListener('click', () => this.activer(i));
          b.addEventListener('keydown', (e) => {
            if (e.key !== 'ArrowRight' && e.key !== 'ArrowLeft') return;
            const n = (i + (e.key === 'ArrowRight' ? 1 : -1) + groupes.length) % groupes.length;
            this.activer(n);
            nav.children[n].focus();
          });
          nav.appendChild(b);
        });
        nav.hidden = false;
        this.classList.add('lfao--pret');
        const actif = groupes.findIndex((g) => !g.hidden && g.dataset.lfaoActif === '1');
        this.activer(actif > -1 ? actif : 0);
      }
      activer(index) {
        const nav = this.querySelector('[data-lfao-nav]');
        this.groupes().forEach((g, i) => {
          const oui = i === index;
          g.hidden = !oui;
          g.dataset.lfaoActif = oui ? '1' : '0';
          if (nav && nav.children[i]) {
            nav.children[i].setAttribute('aria-selected', oui ? 'true' : 'false');
            nav.children[i].tabIndex = oui ? 0 : -1;
          }
        });
      }
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["lucide-frise-etapes"] && !Shopify.designMode) return;
  try {
    
  (function () {
    if (window.lucideFriseInit) return;
    window.lucideFriseInit = true;

    var DELAI = 40;
    var minuteur = null;

    function mouvementReduit() {
      return !!(window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches);
    }

    function racines() {
      return Array.prototype.slice.call(document.querySelectorAll('.lucide-fe'));
    }

    function etapes(racine) {
      return Array.prototype.slice.call(racine.querySelectorAll('.lucide-fe__etape'));
    }

    function ligneDeclenchement(racine) {
      var seuil = parseFloat(racine.getAttribute('data-lucide-fe-seuil'));
      if (!isFinite(seuil)) seuil = 50;
      return window.innerHeight * seuil / 100;
    }

    function majUne(racine) {
      if (!racine.classList.contains('lucide-fe--anime')) return;
      var frise = racine.querySelector('.lucide-fe__frise');
      if (!frise) return;
      var marqueur = ligneDeclenchement(racine);
      var boite = frise.getBoundingClientRect();
      var part = 0;
      if (boite.height > 0) part = (marqueur - boite.top) / boite.height;
      if (part < 0) part = 0;
      if (part > 1) part = 1;
      racine.style.setProperty('--lfe-remplissage', part.toFixed(4));
      etapes(racine).forEach(function (etape) {
        var point = etape.querySelector('.lucide-fe__point');
        var mesure = (point || etape).getBoundingClientRect();
        etape.classList.toggle('est-active', mesure.top + mesure.height / 2 <= marqueur);
      });
    }

    function maj() {
      racines().forEach(majUne);
    }

    /* Le défilement peut venir de n'importe quel conteneur (.page-wrapper) : on écoute
       en capture sur le document, et on limite la cadence avec un setTimeout. */
    function planifier() {
      if (minuteur) return;
      minuteur = setTimeout(function () {
        minuteur = null;
        maj();
      }, DELAI);
    }

    function initialiser(racine) {
      if (racine.getAttribute('data-lucide-fe-pret') === '1') return;
      racine.setAttribute('data-lucide-fe-pret', '1');
      if (mouvementReduit()) return;
      if (racine.getAttribute('data-lucide-fe-animer') !== '1') return;
      racine.classList.add('lucide-fe--anime');
    }

    function tout() {
      racines().forEach(initialiser);
      maj();
    }

    document.addEventListener('scroll', planifier, { capture: true, passive: true });
    window.addEventListener('resize', planifier, { passive: true });
    window.addEventListener('load', planifier);
    document.addEventListener('shopify:section:load', tout);

    /* Éditeur : sélectionner une étape allume tout jusqu'à elle, pour la voir active. */
    document.addEventListener('shopify:block:select', function (evenement) {
      var cible = evenement.target;
      if (!cible || !cible.querySelector || !cible.classList) return;
      var etape = cible.classList.contains('lucide-fe__etape') ? cible : cible.querySelector('.lucide-fe__etape');
      if (!etape) return;
      var racine = etape.closest('.lucide-fe');
      if (!racine) return;
      var liste = etapes(racine);
      var rang = liste.indexOf(etape);
      liste.forEach(function (autre, i) {
        autre.classList.toggle('est-active', i <= rang);
      });
      racine.style.setProperty('--lfe-remplissage', '1');
    });

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', tout);
    } else {
      tout();
    }
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["lucide-gammes"] && !Shopify.designMode) return;
  try {
    
  (function () {
    if (window.lucideGamInit) return;
    window.lucideGamInit = true;

    /* Animation maison : scrollBy/scrollTo en 'smooth' n'aboutissent pas sur un
       rail à scroll-snap (vérifié au banc le 05/09, le rail revenait toujours à
       sa position d'ancrage). L'assignation directe de scrollLeft, elle, marche
       toujours — on anime donc nous-mêmes, image par image. */
    function defiler(rail, delta) {
      var depart = rail.scrollLeft;
      var maxi = rail.scrollWidth - rail.clientWidth;
      var cible = Math.max(0, Math.min(depart + delta, maxi));
      if (cible === depart) return;
      if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
        rail.scrollLeft = cible;
        return;
      }
      /* l'accrochage (scroll-snap) ré-ancre le rail à CHAQUE image et annule le
         mouvement : on le suspend le temps de l'animation, puis on le rend. */
      var snapAvant = rail.style.scrollSnapType;
      rail.style.scrollSnapType = 'none';
      var duree = 320;
      var debut = null;
      var fini = false;
      /* filet : dans un onglet en arrière-plan requestAnimationFrame est gelé —
         sans ce garde-fou le rail resterait immobile ET sans accrochage. */
      function terminer() {
        if (fini) return;
        fini = true;
        rail.scrollLeft = cible;
        rail.style.scrollSnapType = snapAvant;
      }
      function image(t) {
        if (fini) return;
        if (debut === null) debut = t;
        var p = Math.min((t - debut) / duree, 1);
        var e = p < 0.5 ? 2 * p * p : 1 - Math.pow(-2 * p + 2, 2) / 2;
        rail.scrollLeft = depart + (cible - depart) * e;
        if (p < 1) {
          requestAnimationFrame(image);
        } else {
          terminer();
        }
      }
      requestAnimationFrame(image);
      setTimeout(terminer, duree + 80);
    }

    document.addEventListener('click', function (e) {
      var prec = e.target.closest('[data-lucide-gam-prec]');
      var suiv = e.target.closest('[data-lucide-gam-suiv]');
      if (!prec && !suiv) return;
      var zone = (prec || suiv).closest('.lgam__zone');
      var rail = zone && zone.querySelector('[data-lucide-gam-rail]');
      if (!rail) return;
      var carte = rail.querySelector('.lcga');
      var ecart = parseFloat(getComputedStyle(rail).columnGap) || 20;
      var pas = carte ? carte.getBoundingClientRect().width + ecart : rail.clientWidth * 0.8;
      defiler(rail, prec ? -pas : pas);
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["lucide-ingredients-photo"] && !Shopify.designMode) return;
  try {
    
  (function () {
    if (window.lucideIngredientsPhotoInit) return;
    window.lucideIngredientsPhotoInit = true;

    var ORDI = '(min-width: 780px)';

    function cartes(rail) {
      return rail.querySelectorAll('[data-lig-carte]:not(.est-masquee)');
    }

    /* carte « active » : la première au départ, la dernière au bout ; sinon la plus proche
       du centre (téléphone) ou du bord gauche du retrait (ordinateur) */
    function indexActif(rail) {
      var liste = cartes(rail);
      var n = liste.length;
      if (!n) return 0;
      var maxi = rail.scrollWidth - rail.clientWidth;
      if (rail.scrollLeft <= 2) return 0;
      if (rail.scrollLeft >= maxi - 2) return n - 1;
      var bord = rail.getBoundingClientRect();
      var ordi = window.matchMedia(ORDI).matches;
      var repere = ordi ? bord.left + (parseFloat(getComputedStyle(rail).paddingLeft) || 0) : bord.left + rail.clientWidth / 2;
      var meilleur = 0;
      var ecart = Infinity;
      for (var i = 0; i < n; i++) {
        var rc = liste[i].getBoundingClientRect();
        var d = Math.abs((ordi ? rc.left : rc.left + rc.width / 2) - repere);
        if (d < ecart) {
          ecart = d;
          meilleur = i;
        }
      }
      return meilleur;
    }

    /* position à atteindre pour montrer la carte i : centrée sur téléphone, calée au retrait sur ordinateur */
    function cible(rail, i) {
      var liste = cartes(rail);
      if (!liste.length) return rail.scrollLeft;
      i = Math.max(0, Math.min(i, liste.length - 1));
      var bord = rail.getBoundingClientRect();
      var rc = liste[i].getBoundingClientRect();
      if (window.matchMedia(ORDI).matches) {
        var retrait = parseFloat(getComputedStyle(rail).paddingLeft) || 0;
        return rail.scrollLeft + (rc.left - bord.left) - retrait;
      }
      return rail.scrollLeft + (rc.left + rc.width / 2) - (bord.left + rail.clientWidth / 2);
    }

    function majPoints(rail) {
      var racine = rail.closest('[data-lig]');
      if (!racine) return;
      var actif = indexActif(rail);
      var points = racine.querySelectorAll('[data-lig-point]');
      for (var i = 0; i < points.length; i++) {
        points[i].classList.toggle('est-actif', i === actif);
        if (i === actif) {
          points[i].setAttribute('aria-current', 'true');
        } else {
          points[i].removeAttribute('aria-current');
        }
      }
    }

    /* Le rail est en scroll-snap sur téléphone : scrollTo smooth y échoue (retour à l'ancrage).
       On anime nous-mêmes scrollLeft en suspendant l'accrochage, avec un filet setTimeout
       car requestAnimationFrame est gelé dans un onglet masqué (patron lucide-pack). */
    function defiler(rail, arrivee) {
      var depart = rail.scrollLeft;
      var maxi = rail.scrollWidth - rail.clientWidth;
      arrivee = Math.max(0, Math.min(arrivee, maxi));
      if (Math.abs(arrivee - depart) < 1) return;
      rail.dataset.ligAnim = '1';
      if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
        rail.scrollLeft = arrivee;
        delete rail.dataset.ligAnim;
        majPoints(rail);
        return;
      }
      rail.style.scrollSnapType = 'none';
      var duree = 450;
      var debut = null;
      var fini = false;
      function terminer() {
        if (fini) return;
        fini = true;
        rail.scrollLeft = arrivee;
        rail.style.scrollSnapType = '';
        setTimeout(function () {
          delete rail.dataset.ligAnim;
          majPoints(rail);
        }, 60);
      }
      function image(t) {
        if (fini) return;
        if (debut === null) debut = t;
        var p = Math.min((t - debut) / duree, 1);
        var e = 1 - Math.pow(1 - p, 3);
        rail.scrollLeft = depart + (arrivee - depart) * e;
        if (p < 1) {
          requestAnimationFrame(image);
        } else {
          terminer();
        }
      }
      requestAnimationFrame(image);
      setTimeout(terminer, duree + 100);
    }

    function railDe(el) {
      var racine = el.closest('[data-lig]');
      return racine ? racine.querySelector('[data-lig-rail]') : null;
    }

    /* ----- la fenêtre de l'étiquette ----- */
    function prechauffer(racine) {
      var img = racine && racine.querySelector('.lig__etiquette');
      if (img && img.loading === 'lazy') img.loading = 'eager';
    }
    function dezoomer(fenetre) {
      var zone = fenetre.querySelector('[data-lig-zone]');
      if (zone) zone.classList.remove('est-zoome');
    }
    function fermer(fenetre) {
      dezoomer(fenetre);
      if (typeof fenetre.close === 'function' && fenetre.open) {
        fenetre.close();
      } else {
        fenetre.removeAttribute('open');
      }
      document.documentElement.removeAttribute('scroll-lock');
    }
    function ouvrir(racine) {
      var fenetre = racine.querySelector('[data-lig-fenetre]');
      if (!fenetre) return;
      prechauffer(racine);
      if (!fenetre.dataset.ligPret) {
        fenetre.dataset.ligPret = '1';
        fenetre.addEventListener('close', function () {
          dezoomer(fenetre);
          document.documentElement.removeAttribute('scroll-lock');
        });
      }
      if (typeof fenetre.showModal === 'function') {
        fenetre.showModal();
      } else {
        fenetre.setAttribute('open', '');
      }
      document.documentElement.setAttribute('scroll-lock', '');
    }
    function zoomer(img, e) {
      var zone = img.closest('[data-lig-zone]');
      var fenetre = img.closest('[data-lig-fenetre]');
      if (!zone || !fenetre) return;
      if (zone.classList.contains('est-zoome')) {
        zone.classList.remove('est-zoome');
        return;
      }
      var rect = img.getBoundingClientRect();
      var rx = (e.clientX - rect.left) / rect.width;
      var ry = (e.clientY - rect.top) / rect.height;
      var ratio = parseFloat(fenetre.getAttribute('data-lig-zoom')) || 4;
      zone.style.setProperty('--lig-zoom-l', Math.round(rect.width * ratio) + 'px');
      zone.classList.add('est-zoome');
      zone.scrollLeft = rx * img.offsetWidth - zone.clientWidth / 2;
      zone.scrollTop = ry * img.offsetHeight - zone.clientHeight / 2;
    }

    /* ----- clics : un seul écouteur délégué (la section peut arriver après coup) ----- */
    var bloquerClic = false;
    document.addEventListener('click', function (e) {
      if (bloquerClic) {
        bloquerClic = false;
        if (e.target.closest('[data-lig-rail]')) {
          e.preventDefault();
          e.stopPropagation();
          return;
        }
      }
      var fleche = e.target.closest('[data-lig-fleche]');
      if (fleche) {
        var railF = railDe(fleche);
        if (railF) defiler(railF, cible(railF, indexActif(railF) + (parseInt(fleche.getAttribute('data-lig-fleche'), 10) || 1)));
        return;
      }
      var point = e.target.closest('[data-lig-point]');
      if (point) {
        var railP = railDe(point);
        if (railP) defiler(railP, cible(railP, parseInt(point.getAttribute('data-lig-point'), 10) || 0));
        return;
      }
      var bouton = e.target.closest('[data-lig-ouvrir]');
      if (bouton) {
        e.preventDefault();
        ouvrir(bouton.closest('[data-lig]'));
        return;
      }
      var fenetre = e.target.closest('[data-lig-fenetre]');
      if (!fenetre) return;
      if (e.target.closest('[data-lig-fermer]')) {
        fermer(fenetre);
        return;
      }
      var img = e.target.closest('.lig__etiquette');
      if (img) {
        zoomer(img, e);
        return;
      }
      var zone = fenetre.querySelector('[data-lig-zone]');
      if (zone && zone.classList.contains('est-zoome')) return;
      fermer(fenetre);
    }, true);

    document.addEventListener('pointerover', function (e) {
      var bouton = e.target.closest && e.target.closest('[data-lig-ouvrir]');
      if (bouton) prechauffer(bouton.closest('[data-lig]'));
    });

    /* ----- défilement au doigt : le scroll ne remonte pas, on l'écoute en capture ----- */
    var attente = null;
    document.addEventListener('scroll', function (e) {
      var rail = e.target;
      if (!rail || !rail.hasAttribute || !rail.hasAttribute('data-lig-rail')) return;
      if (rail.dataset.ligAnim) return;
      if (attente) clearTimeout(attente);
      attente = setTimeout(function () { majPoints(rail); }, 80);
    }, true);

    /* ----- glisser à la souris (ordinateur), avec élan ----- */
    var prise = null;
    document.addEventListener('pointerdown', function (e) {
      if (e.pointerType !== 'mouse' || e.button !== 0) return;
      var rail = e.target.closest('[data-lig-rail]');
      if (!rail || rail.scrollWidth <= rail.clientWidth) return;
      prise = { rail: rail, x: e.clientX, depart: rail.scrollLeft, bouge: false, v: 0, dernierX: e.clientX, dernierT: performance.now() };
    });
    document.addEventListener('pointermove', function (e) {
      if (!prise) return;
      var dx = e.clientX - prise.x;
      if (!prise.bouge && Math.abs(dx) > 4) {
        prise.bouge = true;
        prise.rail.classList.add('est-glisse');
      }
      if (!prise.bouge) return;
      e.preventDefault();
      prise.rail.scrollLeft = prise.depart - dx;
      var t = performance.now();
      var dt = t - prise.dernierT;
      if (dt > 0) prise.v = (e.clientX - prise.dernierX) / dt;
      prise.dernierX = e.clientX;
      prise.dernierT = t;
    });
    function lacher() {
      if (!prise) return;
      var p = prise;
      prise = null;
      if (!p.bouge) return;
      bloquerClic = true;
      setTimeout(function () { bloquerClic = false; }, 0);
      var v = -p.v;
      var avant = performance.now();
      function elan(t) {
        var dt = t - avant;
        avant = t;
        p.rail.scrollLeft += v * dt;
        v *= Math.pow(0.95, dt / 16);
        if (Math.abs(v) > 0.02) {
          requestAnimationFrame(elan);
        } else {
          p.rail.classList.remove('est-glisse');
          majPoints(p.rail);
        }
      }
      if (Math.abs(v) > 0.05 && !window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
        requestAnimationFrame(elan);
        setTimeout(function () { p.rail.classList.remove('est-glisse'); }, 1500);
      } else {
        p.rail.classList.remove('est-glisse');
        majPoints(p.rail);
      }
    }
    document.addEventListener('pointerup', lacher);
    document.addEventListener('pointercancel', lacher);
    document.addEventListener('dragstart', function (e) {
      if (e.target.closest && e.target.closest('[data-lig-rail]')) e.preventDefault();
    });

    /* ----- les boutons sous le titre (Omar 12/10) : un par gamme (cartes au même « Bouton sous le
       titre »), plus « Tout » si la section le demande. Un clic n'affiche que les cartes de la gamme
       (néon de sa couleur) ; « Tout » ou un second clic les remet toutes. ----- */
    function filtrer(cadre, bouton) {
      var rail = cadre.querySelector('[data-lig-rail]');
      var choisi = bouton.ligCartes && bouton.getAttribute('aria-pressed') !== 'true' ? bouton : null;
      var boutons = cadre.querySelectorAll('.lig__choix');
      for (var i = 0; i < boutons.length; i++) {
        boutons[i].setAttribute('aria-pressed', boutons[i] === choisi || (!choisi && !boutons[i].ligCartes) ? 'true' : 'false');
      }
      var toutes = rail.querySelectorAll('[data-lig-carte]');
      for (var j = 0; j < toutes.length; j++) toutes[j].classList.toggle('est-masquee', !!choisi && choisi.ligCartes.indexOf(toutes[j]) < 0);
      var n = cartes(rail).length;
      var points = cadre.querySelectorAll('[data-lig-point]');
      for (var k = 0; k < points.length; k++) points[k].classList.toggle('est-masque', k >= n);
      rail.scrollLeft = 0;
      majPoints(rail);
    }
    function boutonChoix(cadre, texte, groupe) {
      var b = document.createElement('button');
      b.type = 'button';
      b.className = groupe ? 'lig__choix' : 'lig__choix lig__choix--tout';
      b.setAttribute('aria-pressed', groupe ? 'false' : 'true');
      b.textContent = texte;
      b.insertAdjacentHTML('beforeend', '<svg aria-hidden="true" viewBox="0 0 12 12" width="10" height="10"><path d="M2 6h8M6.5 2.5 10 6l-3.5 3.5" fill="none" stroke="currentColor" stroke-width="1.4" stroke-linecap="round" stroke-linejoin="round"/></svg>');
      if (groupe && groupe.style) b.style.cssText = groupe.style;
      b.ligCartes = groupe ? groupe.cartes : null;
      b.addEventListener('click', function () { filtrer(cadre, b); });
      return b;
    }
    function rangerChoix(racine) {
      var cadres = (racine || document).querySelectorAll('.lig__cadre');
      for (var c = 0; c < cadres.length; c++) {
        var cadre = cadres[c];
        var vieux = cadre.querySelector('.lig__choix-rang');
        if (vieux) vieux.remove();
        var entete = cadre.querySelector('.lig__entete');
        var liste = cadre.querySelectorAll('[data-lig-choix]');
        if (!entete || !liste.length) continue;
        var rang = document.createElement('div');
        rang.className = 'lig__choix-rang';
        var groupes = [];
        var parNom = {};
        for (var i = 0; i < liste.length; i++) {
          var nom = liste[i].dataset.ligChoix;
          if (!parNom[nom]) {
            parNom[nom] = { nom: nom, style: liste[i].dataset.ligStyle || '', cartes: [] };
            groupes.push(parNom[nom]);
          }
          parNom[nom].cartes.push(liste[i]);
        }
        if (cadre.dataset.ligTout) rang.appendChild(boutonChoix(cadre, cadre.dataset.ligTout, null));
        for (var g = 0; g < groupes.length; g++) rang.appendChild(boutonChoix(cadre, groupes[g].nom, groupes[g]));
        entete.appendChild(rang);
      }
    }
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', function () { rangerChoix(); });
    } else {
      rangerChoix();
    }
    document.addEventListener('shopify:section:load', function (e) { rangerChoix(e.target); });

    /* ----- éditeur : sélectionner une carte la fait venir à l'écran ----- */
    document.addEventListener('shopify:block:select', function (e) {
      var carte = e.target.matches && e.target.matches('[data-lig-carte]') ? e.target : e.target.querySelector && e.target.querySelector('[data-lig-carte]');
      if (!carte) return;
      var rail = carte.closest('[data-lig-rail]');
      if (!rail) return;
      var liste = cartes(rail);
      for (var i = 0; i < liste.length; i++) {
        if (liste[i] === carte) {
          defiler(rail, cible(rail, i));
          break;
        }
      }
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["lucide-ingredients"] && !Shopify.designMode) return;
  try {
    
  (function () {
    if (window.lucideIngInit) return;
    window.lucideIngInit = true;

    /* Flèches du carrousel : délégation, rien à initialiser (fiable dans l'éditeur). */
    document.addEventListener('click', function (e) {
      var prec = e.target.closest('[data-lucide-prec]');
      var suiv = e.target.closest('[data-lucide-suiv]');
      if (!prec && !suiv) return;
      var bande = (prec || suiv).closest('.lucide-ing__bande');
      var rail = bande && bande.querySelector('[data-lucide-rail]');
      if (!rail) return;
      var carte = rail.querySelector('.lucide-ing-item');
      var pas = carte ? carte.getBoundingClientRect().width + 16 : rail.clientWidth / 2;
      rail.scrollBy({ left: prec ? -pas : pas, behavior: 'smooth' });
    });

    /* ----- Onglets de gammes (Focus / Calm…) ----- */
    /* Le libellé de chaque carte voyage en data-attribut (une section ne lit pas les
       réglages de ses blocs). 2 libellés distincts minimum = rangée d'onglets. */
    function appliquerOnglet(racine, libelle) {
      var conteneur = racine.querySelector('[data-lucide-ing-onglets]');
      if (!conteneur) return;
      conteneur.setAttribute('data-actif', libelle);
      Array.prototype.forEach.call(conteneur.children, function (b) {
        b.classList.toggle('est-actif', b.getAttribute('data-onglet') === libelle);
      });
      Array.prototype.forEach.call(racine.querySelectorAll('.lucide-ing-item'), function (item) {
        var l = (item.getAttribute('data-lucide-ing-onglet') || '').trim();
        /* une carte sans onglet reste visible partout */
        item.classList.toggle('est-cache', l !== '' && l !== libelle);
      });
      var rail = racine.querySelector('[data-lucide-rail]');
      if (rail) rail.scrollTo({ left: 0 });
    }

    function initOnglets() {
      Array.prototype.forEach.call(document.querySelectorAll('.lucide-ing'), function (racine) {
        var conteneur = racine.querySelector('[data-lucide-ing-onglets]');
        if (!conteneur) return;
        var libelles = [];
        Array.prototype.forEach.call(racine.querySelectorAll('.lucide-ing-item'), function (item) {
          var l = (item.getAttribute('data-lucide-ing-onglet') || '').trim();
          if (l && libelles.indexOf(l) === -1) libelles.push(l);
        });
        if (libelles.length < 2) {
          conteneur.innerHTML = '';
          conteneur.hidden = true;
          Array.prototype.forEach.call(racine.querySelectorAll('.lucide-ing-item.est-cache'), function (item) {
            item.classList.remove('est-cache');
          });
          return;
        }
        var actif = conteneur.getAttribute('data-actif');
        if (!actif || libelles.indexOf(actif) === -1) actif = libelles[0];
        conteneur.innerHTML = '';
        libelles.forEach(function (l) {
          var b = document.createElement('button');
          b.type = 'button';
          b.className = 'lucide-ing__onglet';
          b.setAttribute('data-onglet', l);
          b.textContent = l;
          conteneur.appendChild(b);
        });
        conteneur.hidden = false;
        appliquerOnglet(racine, actif);
      });
    }

    document.addEventListener('click', function (e) {
      var b = e.target.closest('.lucide-ing__onglet');
      if (!b) return;
      appliquerOnglet(b.closest('.lucide-ing'), b.getAttribute('data-onglet'));
    });

    /* Éditeur : reconstruire au rechargement de la section, et montrer l'onglet
       de la carte qu'Omar sélectionne */
    document.addEventListener('shopify:section:load', initOnglets);
    document.addEventListener('shopify:block:select', function (e) {
      var item = e.target && e.target.closest ? e.target.closest('.lucide-ing-item') : null;
      if (!item) return;
      var l = (item.getAttribute('data-lucide-ing-onglet') || '').trim();
      if (l) appliquerOnglet(item.closest('.lucide-ing'), l);
    });

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', initOnglets);
    } else {
      initOnglets();
    }
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["lucide-mur-avis"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('lucide-mur-avis')) {
    customElements.define(
      'lucide-mur-avis',
      class extends HTMLElement {
        connectedCallback() {
          this.rail = this.querySelector('[data-lam-rail]');
          this.zonePoints = this.querySelector('[data-lam-points]');
          this.lecteur = this.querySelector('[data-lam-lecteur]');
          if (!this.rail) return;
          this.cartes = Array.from(this.rail.querySelectorAll('.lamx'));

          this.fabriquerPoints();
          this.rail.addEventListener('scroll', () => this.marquerPoint(), { passive: true });
          this.marquerPoint();

          var prec = this.querySelector('[data-lam-prec]');
          var suiv = this.querySelector('[data-lam-suiv]');
          if (prec) prec.addEventListener('click', () => this.pas(-1));
          if (suiv) suiv.addEventListener('click', () => this.pas(1));

          this.addEventListener('click', (e) => {
            if (e.target.closest('[data-lam-ouvrir]')) {
              if (this.dataset.lecture === 'plein_ecran') this.ouvrir(e.target.closest('.lamx'));
              else this.lireDansCarte(e.target.closest('.lamx'));
            } else if (e.target.closest('[data-lam-fermer]')) {
              this.fermer();
            }
          });
          if (this.lecteur) {
            this.lecteur.addEventListener('close', () => {
              this.lecteur.querySelector('[data-lam-scene]').innerHTML = '';
              document.documentElement.removeAttribute('scroll-lock');
            });
          }
          this.addEventListener('shopify:block:select', (e) => {
            var carte = e.target.closest ? e.target.closest('.lamx') : null;
            var i = this.cartes.indexOf(carte);
            if (i >= 0) this.allerA(i);
          });
        }

        fabriquerPoints() {
          if (!this.zonePoints) return;
          this.zonePoints.innerHTML = '';
          this.points = this.cartes.map((carte, i) => {
            var b = document.createElement('button');
            b.type = 'button';
            b.className = 'lmav__point';
            b.setAttribute('aria-label', 'Avis ' + (i + 1));
            b.addEventListener('click', () => this.allerA(i));
            this.zonePoints.appendChild(b);
            return b;
          });
        }

        /* index de la carte la plus proche du centre du rail */
        indexCourant() {
          var centre = this.rail.scrollLeft + this.rail.clientWidth / 2;
          var meilleur = 0;
          var ecartMini = Infinity;
          this.cartes.forEach((c, i) => {
            var milieu = c.offsetLeft + c.offsetWidth / 2;
            var ecart = Math.abs(milieu - centre);
            if (ecart < ecartMini) {
              ecartMini = ecart;
              meilleur = i;
            }
          });
          return meilleur;
        }

        marquerPoint() {
          if (!this.points) return;
          var i = this.indexCourant();
          this.points.forEach((p, j) => p.setAttribute('aria-current', j === i ? 'true' : 'false'));
        }

        pas(sens) {
          this.allerA(this.indexCourant() + sens);
        }

        /* Défilement animé maison : scrollTo/scrollBy en 'smooth' n'aboutissent pas
           sur un rail à scroll-snap (l'accrochage annule le mouvement), et
           requestAnimationFrame est gelé dans un onglet en arrière-plan — d'où le
           filet setTimeout qui pose la position finale et rend l'accrochage. */
        allerA(i) {
          var n = this.cartes.length;
          if (!n) return;
          i = Math.max(0, Math.min(i, n - 1));
          var carte = this.cartes[i];
          var cible = carte.offsetLeft - (this.rail.clientWidth - carte.offsetWidth) / 2;
          cible = Math.max(0, Math.min(cible, this.rail.scrollWidth - this.rail.clientWidth));
          var depart = this.rail.scrollLeft;
          if (Math.abs(cible - depart) < 1) return;

          var snapAvant = this.rail.style.scrollSnapType;
          this.rail.style.scrollSnapType = 'none';
          var fini = false;
          var self = this;
          function terminer() {
            if (fini) return;
            fini = true;
            self.rail.scrollLeft = cible;
            self.rail.style.scrollSnapType = snapAvant;
            self.marquerPoint();
          }
          if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
            terminer();
            return;
          }
          var duree = 340;
          var debut = null;
          function image(t) {
            if (fini) return;
            if (debut === null) debut = t;
            var p = Math.min((t - debut) / duree, 1);
            var e = p < 0.5 ? 2 * p * p : 1 - Math.pow(-2 * p + 2, 2) / 2;
            self.rail.scrollLeft = depart + (cible - depart) * e;
            if (p < 1) {
              requestAnimationFrame(image);
            } else {
              terminer();
            }
          }
          requestAnimationFrame(image);
          setTimeout(terminer, duree + 80);
        }

        /* La vidéo se lance dans sa carte (playsinline : pas de plein écran sur iPhone) ;
           un clic de plus = pause ; une seule vidéo joue à la fois. */
        lireDansCarte(carte) {
          if (!carte) return;
          var zone = carte.querySelector('.lamx__media');
          var video = zone && zone.querySelector('video.lamx__video');
          if (!video) {
            var source = carte.querySelector('.lamx__source video');
            if (!source || !zone) return;
            video = source.cloneNode(true);
            video.classList.add('lamx__video');
            video.controls = false;
            video.playsInline = true;
            video.setAttribute('playsinline', '');
            video.addEventListener('ended', function () { carte.classList.remove('lamx--joue'); });
            zone.appendChild(video);
          }
          if (video.paused) {
            this.querySelectorAll('video.lamx__video').forEach(function (autre) {
              if (autre !== video && !autre.paused) {
                autre.pause();
                autre.closest('.lamx').classList.remove('lamx--joue');
              }
            });
            video.muted = false;
            video.play().catch(function () {});
            carte.classList.add('lamx--joue');
          } else {
            video.pause();
            carte.classList.remove('lamx--joue');
          }
        }

        ouvrir(carte) {
          if (!carte || !this.lecteur) return;
          var source = carte.querySelector('.lamx__source video');
          var scene = this.lecteur.querySelector('[data-lam-scene]');
          scene.innerHTML = '';
          if (!source) return;
          var video = source.cloneNode(true);
          video.muted = false;
          video.controls = false;
          scene.appendChild(video);
          try { this.lecteur.showModal(); } catch (err) {}
          document.documentElement.setAttribute('scroll-lock', '');
          video.currentTime = 0;
          video.play().catch(function () {});
          video.addEventListener('click', function () {
            if (video.paused) { video.play().catch(function () {}); } else { video.pause(); }
          });
        }

        fermer() {
          if (!this.lecteur) return;
          try { this.lecteur.close(); } catch (e) {}
        }
      }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["lucide-mur-photos"] && !Shopify.designMode) return;
  try {
    
  // Lien du bouton laissé vide : défile jusqu'à la section « Routine » de la page, sous l'en-tête.
  // Sur ordinateur c'est .page-wrapper qui défile, pas la page : on fait défiler le bon cadre.
  document.addEventListener('click', (evenement) => {
    const bouton = evenement.target.closest('[data-lmph-routine]');
    if (!bouton) return;
    const routine = document.querySelector('lucide-routine');
    if (!routine) return;
    evenement.preventDefault();
    const cible = routine.closest('.shopify-section') || routine;
    let cadre = document.scrollingElement;
    for (let p = cible.parentElement; p; p = p.parentElement) {
      if (/auto|scroll/.test(getComputedStyle(p).overflowY) && p.scrollHeight > p.clientHeight + 10) { cadre = p; break; }
    }
    const origine = cadre === document.scrollingElement ? 0 : cadre.getBoundingClientRect().top;
    const entete = parseFloat(getComputedStyle(document.body).getPropertyValue('--header-height')) || 0;
    const doux = !window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    cadre.scrollTo({ top: cadre.scrollTop + cible.getBoundingClientRect().top - origine - entete, behavior: doux ? 'smooth' : 'auto' });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["lucide-pack"] && !Shopify.designMode) return;
  try {
    
  (function () {
    if (window.lucidePackInit) return;
    window.lucidePackInit = true;

    /* Le rail est en scroll-snap : scrollTo({behavior:'smooth'}) échoue dessus (le
       rail revient à son ancrage — vérifié au banc le 05/09 sur « Nos gammes »).
       On anime donc nous-mêmes scrollLeft, en suspendant l'accrochage le temps du
       mouvement, avec un filet setTimeout car requestAnimationFrame est gelé dans un
       onglet en arrière-plan. */
    function defiler(rail, cible) {
      var depart = rail.scrollLeft;
      var maxi = rail.scrollWidth - rail.clientWidth;
      cible = Math.max(0, Math.min(cible, maxi));
      if (Math.abs(cible - depart) < 1) return;
      rail.dataset.lpkAnim = '1';
      if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
        rail.scrollLeft = cible;
        delete rail.dataset.lpkAnim;
        majPoints(rail);
        return;
      }
      var snapAvant = rail.style.scrollSnapType;
      rail.style.scrollSnapType = 'none';
      var duree = 320;
      var debut = null;
      var fini = false;
      function terminer() {
        if (fini) return;
        fini = true;
        rail.scrollLeft = cible;
        rail.style.scrollSnapType = snapAvant;
        setTimeout(function () {
          delete rail.dataset.lpkAnim;
          majPoints(rail);
        }, 60);
      }
      function image(t) {
        if (fini) return;
        if (debut === null) debut = t;
        var p = Math.min((t - debut) / duree, 1);
        var e = p < 0.5 ? 2 * p * p : 1 - Math.pow(-2 * p + 2, 2) / 2;
        rail.scrollLeft = depart + (cible - depart) * e;
        if (p < 1) {
          requestAnimationFrame(image);
        } else {
          terminer();
        }
      }
      requestAnimationFrame(image);
      setTimeout(terminer, duree + 80);
    }

    function majPoints(rail) {
      var galerie = rail.closest('.lpk__galerie');
      if (!galerie || !rail.clientWidth) return;
      var index = Math.round(rail.scrollLeft / rail.clientWidth);
      var points = galerie.querySelectorAll('[data-lpk-point]');
      for (var i = 0; i < points.length; i++) {
        points[i].classList.toggle('est-actif', i === index);
        points[i].setAttribute('aria-selected', i === index ? 'true' : 'false');
      }
    }

    /* clic sur un point : événement délégué, la section peut arriver après coup (éditeur) */
    document.addEventListener('click', function (e) {
      var point = e.target.closest('[data-lpk-point]');
      if (!point) return;
      var galerie = point.closest('.lpk__galerie');
      var rail = galerie && galerie.querySelector('[data-lpk-rail]');
      if (!rail) return;
      var index = parseInt(point.getAttribute('data-lpk-point'), 10) || 0;
      defiler(rail, index * rail.clientWidth);
    });

    /* défilement au doigt : le scroll ne remonte pas, on l'écoute en phase de capture ;
       setTimeout plutôt que requestAnimationFrame (gelé dans un onglet masqué). */
    var attente = null;
    document.addEventListener('scroll', function (e) {
      var rail = e.target;
      if (!rail || !rail.hasAttribute || !rail.hasAttribute('data-lpk-rail')) return;
      if (rail.dataset.lpkAnim) return;
      if (attente) clearTimeout(attente);
      attente = setTimeout(function () { majPoints(rail); }, 80);
    }, true);
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["lucide-panier-colle"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('lucide-panier-colle')) {
    const VARIABLES = ['--lech-cta-f', '--lech-cta-c', '--lech-cta-r', '--lech-cta-h', '--lech-cta-h-m', '--lech-cta-p', '--lech-cta-t', '--lech-cta-t-m', '--lech-cta-g', '--lech-cta-tt', '--lech-cta-ls', '--lech-cta-ls-m', '--lech-h0', '--lech-h1', '--lech-h2', '--lech-l1', '--lech-l2', '--lech-l3'];
    customElements.define(
      'lucide-panier-colle',
      class extends HTMLElement {
        connectedCallback() {
          const cta = document.querySelector('[data-lech-cta]');
          if (!cta) return;
          const offre = cta.closest('lucide-echelle') || cta;
          const repere = cta.closest('.lech-cta-l') || cta;
          const bouton = this.querySelector('.lpc__bouton');

          // réserve sous le pied de page la hauteur de la barre (0 si elle est masquée sur cet écran)
          const boite = this.querySelector('.lpc__boite');
          this.mesure = new ResizeObserver(() => document.documentElement.style.setProperty('--lpc-reserve', `${boite.offsetHeight}px`));
          this.mesure.observe(boite);

          // même format que le bouton du bundle : ses variables, son néon, son pictogramme
          const style = getComputedStyle(cta);
          VARIABLES.forEach((nom) => {
            const valeur = style.getPropertyValue(nom).trim();
            if (valeur) this.style.setProperty(nom, valeur);
          });
          bouton.classList.toggle('lpc__bouton--neon', cta.classList.contains('lech-cta--neon'));
          const picto = cta.querySelector('.lech-cta__ic');
          if (picto && !bouton.querySelector('.lech-cta__ic')) bouton.prepend(picto.cloneNode(true));

          // visible dès que le bouton du bundle est sorti de l'écran par le haut
          this.verifier = () => {
            const passe = repere.getBoundingClientRect().bottom < 0;
            this.classList.toggle('lpc--visible', passe);
            this.toggleAttribute('inert', !passe);
          };
          this.surDefile = () => {
            if (this.attente) return;
            this.attente = requestAnimationFrame(() => {
              this.attente = 0;
              this.verifier();
            });
          };
          document.addEventListener('scroll', this.surDefile, { capture: true, passive: true });
          window.addEventListener('resize', this.surDefile, { passive: true });
          this.verifier();

          // au clic : remonter jusqu'au bundle, sous l'en-tête
          bouton.addEventListener('click', () => {
            let cadre = document.scrollingElement;
            for (let p = offre.parentElement; p; p = p.parentElement) {
              if (/auto|scroll/.test(getComputedStyle(p).overflowY) && p.scrollHeight > p.clientHeight + 10) {
                cadre = p;
                break;
              }
            }
            const origine = cadre === document.scrollingElement ? 0 : cadre.getBoundingClientRect().top;
            const entete = parseFloat(getComputedStyle(document.body).getPropertyValue('--header-height')) || 0;
            const doux = !window.matchMedia('(prefers-reduced-motion: reduce)').matches;
            cadre.scrollTo({ top: cadre.scrollTop + offre.getBoundingClientRect().top - origine - entete - 16, behavior: doux ? 'smooth' : 'auto' });
          });
        }
        disconnectedCallback() {
          document.removeEventListener('scroll', this.surDefile, { capture: true });
          window.removeEventListener('resize', this.surDefile);
          if (this.attente) cancelAnimationFrame(this.attente);
          if (this.mesure) this.mesure.disconnect();
          document.documentElement.style.removeProperty('--lpc-reserve');
        }
      }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["lucide-parutions"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('lucide-parutions')) {
    customElements.define(
      'lucide-parutions',
      class extends HTMLElement {
        connectedCallback() {
          this.rail = this.querySelector('[data-lprt-rail]');
          this.zoneCitations = this.querySelector('[data-lprt-citations]');
          this.zoneLegendes = this.querySelector('[data-lprt-legendes]');
          this.zonePoints = this.querySelector('[data-lprt-points]');
          this.parutions = Array.from(this.querySelectorAll('.lprt__parution'));
          if (!this.rail || !this.parutions.length) return;

          this.citations = [];
          this.legendes = [];
          this.points = [];

          this.parutions.forEach((p, i) => {
            const citation = p.querySelector('.lprt__citation');
            const legende = p.querySelector('.lprt__legende');
            if (citation && this.zoneCitations) {
              this.zoneCitations.appendChild(citation);
              this.citations[i] = citation;
            }
            if (legende && this.zoneLegendes) {
              this.zoneLegendes.appendChild(legende);
              this.legendes[i] = legende;
            }
            const bouton = p.querySelector('.lprt__logo');
            if (bouton) bouton.addEventListener('click', () => this.choisir(i, true));

            if (this.zonePoints) {
              const point = document.createElement('button');
              point.type = 'button';
              point.className = 'lprt__point';
              point.setAttribute('aria-label', 'Parution ' + (i + 1));
              point.addEventListener('click', () => this.choisir(i, true));
              this.zonePoints.appendChild(point);
              this.points[i] = point;
            }
          });

          if (this.zonePoints && this.points.length > 1) this.zonePoints.hidden = false;

          this.choisir(0, false);
          requestAnimationFrame(() => this.centrer(0, 'auto'));

          // Glissement au doigt : l'actif devient le logo le plus proche du centre.
          let minuteur = null;
          this.rail.addEventListener('scroll', () => {
            if (minuteur) clearTimeout(minuteur);
            if (this.centrageAuto) return;
            minuteur = setTimeout(() => {
              const i = this.indexCentre();
              if (i >= 0 && i !== this.index) this.choisir(i, false);
            }, 120);
          });

          this.demarrerRotation();
          ['pointerdown', 'focusin'].forEach((e) => this.addEventListener(e, () => this.arreterRotation()));

          this.addEventListener('shopify:block:select', (e) => {
            const p = e.target && e.target.closest ? e.target.closest('.lprt__parution') : null;
            const i = this.parutions.indexOf(p);
            if (i >= 0) {
              this.arreterRotation();
              this.choisir(i, true);
            }
          });
        }

        disconnectedCallback() {
          this.arreterRotation();
        }

        indexCentre() {
          const cadre = this.rail.getBoundingClientRect();
          const milieu = cadre.left + cadre.width / 2;
          let gagnant = -1;
          let meilleur = Infinity;
          this.parutions.forEach((p, i) => {
            const b = p.getBoundingClientRect();
            const d = Math.abs(b.left + b.width / 2 - milieu);
            if (d < meilleur) {
              meilleur = d;
              gagnant = i;
            }
          });
          return gagnant;
        }

        choisir(i, centrer) {
          this.index = i;
          this.parutions.forEach((p, j) => p.classList.toggle('est-actif', j === i));
          this.citations.forEach((c, j) => {
            if (c) c.toggleAttribute('hidden', j !== i);
          });
          this.legendes.forEach((l, j) => {
            if (l) l.toggleAttribute('hidden', j !== i);
          });
          this.points.forEach((p, j) => p.classList.toggle('est-actif', j === i));
          if (centrer) this.centrer(i);
        }

        centrer(i, comportement) {
          const p = this.parutions[i];
          if (!p || this.rail.scrollWidth <= this.rail.clientWidth) return;
          const cible = p.offsetLeft - (this.rail.clientWidth - p.offsetWidth) / 2;
          // Drapeau : sans lui, le défilement que NOUS déclenchons réveille le
          // détecteur « logo le plus proche du centre », qui rebascule aussitôt
          // sur l'ancien logo et annule le centrage.
          this.centrageAuto = true;
          if (this.finCentrage) clearTimeout(this.finCentrage);
          this.finCentrage = setTimeout(() => {
            this.centrageAuto = false;
          }, 700);
          const depart = this.rail.scrollLeft;
          const arrivee = Math.max(0, cible);
          this.rail.scrollTo({ left: arrivee, behavior: comportement || 'smooth' });
          // Filet : dans un onglet masqué (aperçu, éditeur), le glissement animé
          // n'est jamais joué — on pose alors la position sèchement.
          setTimeout(() => {
            if (this.rail.scrollLeft === depart && Math.abs(depart - arrivee) > 4) {
              this.rail.scrollLeft = arrivee;
            }
          }, 320);
        }

        demarrerRotation() {
          const secondes = parseFloat(this.dataset.lprtAuto || '0');
          if (!secondes || this.parutions.length < 2) return;
          if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;
          this.horloge = setInterval(() => {
            this.choisir((this.index + 1) % this.parutions.length, true);
          }, secondes * 1000);
        }

        arreterRotation() {
          if (this.horloge) {
            clearInterval(this.horloge);
            this.horloge = null;
          }
        }
      }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["lucide-profils"] && !Shopify.designMode) return;
  try {
    
  // Glisser le rail à la souris (le doigt et le pavé tactile défilent déjà nativement).
  if (!customElements.get('lucide-profils')) {
    customElements.define('lucide-profils', class extends HTMLElement {
      connectedCallback() {
        const rail = this.querySelector('[data-lpf-rail]');
        if (!rail || rail.dataset.lpfPret) return;
        rail.dataset.lpfPret = '1';
        let depart = null;
        let bouge = false;
        rail.addEventListener('pointerdown', (e) => {
          if (e.pointerType !== 'mouse' || e.button !== 0) return;
          depart = { x: e.clientX, gauche: rail.scrollLeft };
          bouge = false;
        });
        window.addEventListener('pointermove', (e) => {
          if (!depart) return;
          const dx = e.clientX - depart.x;
          if (!bouge && Math.abs(dx) > 5) { bouge = true; rail.classList.add('lpf--glisse'); }
          if (bouge) rail.scrollLeft = depart.gauche - dx;
        });
        window.addEventListener('pointerup', () => {
          if (!depart) return;
          depart = null;
          if (!bouge) return;
          rail.classList.remove('lpf--glisse');
          const pas = rail.querySelector('.lpf__carte');
          if (pas) {
            const largeur = pas.getBoundingClientRect().width + parseFloat(getComputedStyle(rail).columnGap || 0);
            rail.scrollTo({ left: Math.round(rail.scrollLeft / largeur) * largeur, behavior: 'smooth' });
          }
        });
        rail.addEventListener('click', (e) => { if (bouge) { e.preventDefault(); e.stopPropagation(); bouge = false; } }, true);
      }
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["lucide-resultats-verre"] && !Shopify.designMode) return;
  try {
    
  (function () {
    if (window.lucideVerreInit) return;
    window.lucideVerreInit = true;

    function jouer(nombres, duree) {
      var cibles = nombres.map(function (n) {
        return parseInt(n.getAttribute('data-cible'), 10);
      });
      nombres.forEach(function (n) { n.textContent = '0'; });

      var depart = Date.now();
      var minuteur = setInterval(function () {
        var p = (Date.now() - depart) / (duree * 1000);
        if (p > 1) p = 1;
        var e = 1 - Math.pow(1 - p, 3);
        nombres.forEach(function (n, i) {
          n.textContent = String(Math.round(cibles[i] * e));
        });
        if (p >= 1) {
          clearInterval(minuteur);
          nombres.forEach(function (n) {
            n.textContent = n.getAttribute('data-cible');
          });
        }
      }, 30);
    }

    function initialiser(racine) {
      if (racine.dataset.lucidePret) return;
      racine.dataset.lucidePret = '1';

      if (racine.getAttribute('data-anim') !== 'true') return;
      if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;

      var nombres = Array.prototype.slice
        .call(racine.querySelectorAll('[data-lucide-nombre]'))
        .filter(function (n) {
          return /^[0-9]+$/.test(n.getAttribute('data-cible') || '');
        });
      if (!nombres.length) return;

      var duree = parseFloat(racine.getAttribute('data-duree')) || 1.5;

      var observateur = new IntersectionObserver(function (entrees) {
        entrees.forEach(function (entree) {
          if (!entree.isIntersecting) return;
          observateur.disconnect();
          jouer(nombres, duree);
        });
      }, { threshold: 0.3 });
      observateur.observe(racine);
    }

    function tout() {
      document.querySelectorAll('[data-lucide-verre]').forEach(initialiser);
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', tout);
    } else {
      tout();
    }

    document.addEventListener('shopify:section:load', function () {
      document.querySelectorAll('[data-lucide-verre]').forEach(function (r) {
        delete r.dataset.lucidePret;
      });
      tout();
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["lucide-routine"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('lucide-routine')) {
    customElements.define(
      'lucide-routine',
      class extends HTMLElement {
        connectedCallback() {
          if (document.readyState === 'loading') {
            document.addEventListener('DOMContentLoaded', () => this.#ranger(), { once: true });
          } else {
            this.#ranger();
          }
        }

        /* un bouton par nom de filtre (dans l'ordre des cartes), « Tout » devant et choisi à l'arrivée */
        #ranger() {
          const rang = this.querySelector('[data-lrt-filtres]');
          if (!rang) return;
          rang.textContent = '';
          const groupes = new Map();
          for (const carte of this.querySelectorAll('[data-lrt-carte]')) {
            const nom = (carte.dataset.lrtFiltre || '').trim();
            if (!nom) continue;
            if (!groupes.has(nom)) groupes.set(nom, { style: carte.dataset.lrtStyle || '', cartes: [] });
            groupes.get(nom).cartes.push(carte);
          }
          rang.hidden = groupes.size === 0;
          if (this.dataset.lrtTout) rang.append(this.#bouton(this.dataset.lrtTout, null));
          for (const [nom, groupe] of groupes) rang.append(this.#bouton(nom, groupe));
          this.toutAfficher();
        }

        #bouton(texte, groupe) {
          const b = document.createElement('button');
          b.type = 'button';
          b.className = 'lrt__filtre';
          b.textContent = texte;
          if (groupe) b.style.cssText = groupe.style;
          b.lrtCartes = groupe ? groupe.cartes : null;
          b.addEventListener('click', () => this.#filtrer(b));
          return b;
        }

        /* une gamme choisie = ses cartes seules ; « Tout » ou un second clic = toutes */
        #filtrer(bouton) {
          const choisi = bouton && bouton.lrtCartes && bouton.getAttribute('aria-pressed') !== 'true' ? bouton : null;
          for (const b of this.querySelectorAll('.lrt__filtre')) {
            b.setAttribute('aria-pressed', String(b === choisi || (!choisi && !b.lrtCartes)));
          }
          for (const carte of this.querySelectorAll('[data-lrt-carte]')) {
            carte.classList.toggle('est-masquee', Boolean(choisi) && !choisi.lrtCartes.includes(carte));
          }
        }

        toutAfficher() {
          this.#filtrer(null);
        }
      }
    );
    /* éditeur : une carte sélectionnée mais filtrée réapparaît */
    document.addEventListener('shopify:block:select', (e) => {
      const carte = e.target.closest && e.target.closest('[data-lrt-carte]');
      const racine = carte && carte.closest('lucide-routine');
      if (racine && carte.classList.contains('est-masquee')) racine.toutAfficher();
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["lucide-science"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('lucide-science')) {
    customElements.define(
      'lucide-science',
      class extends HTMLElement {
        connectedCallback() {
          const zonePhoto = this.querySelector('.lsci__zone-photo');
          const zoneCitation = this.querySelector('.lsci__zone-citation');
          const bandeau = this.querySelector('.lsci__bandeau');
          this.personnes = Array.from(this.querySelectorAll('.lsci__personne'));
          if (!zonePhoto || !zoneCitation || !this.personnes.length) return;
          this.cartes = [];
          this.citations = [];
          this.personnes.forEach((p, i) => {
            const carte = p.querySelector('.lsci__carte');
            const citation = p.querySelector('.lsci__citation');
            if (carte) {
              zonePhoto.insertBefore(carte, bandeau);
              this.cartes[i] = carte;
            }
            if (citation) {
              zoneCitation.appendChild(citation);
              this.citations[i] = citation;
            }
            const radio = p.querySelector('.lsci__radio');
            if (radio) radio.addEventListener('change', () => this.montrer(i));
          });
          this.classList.add('lsci--prete');
          let depart = this.personnes.findIndex((p) => {
            const radio = p.querySelector('.lsci__radio');
            return radio && radio.checked;
          });
          if (depart < 0) depart = 0;
          const premier = this.personnes[depart].querySelector('.lsci__radio');
          if (premier) premier.checked = true;
          this.montrer(depart);
          this.addEventListener('shopify:block:select', (e) => {
            const p = e.target && e.target.closest ? e.target.closest('.lsci__personne') : null;
            const i = this.personnes.indexOf(p);
            if (i >= 0) {
              const radio = p.querySelector('.lsci__radio');
              if (radio) radio.checked = true;
              this.montrer(i);
            }
          });
        }
        montrer(i) {
          this.cartes.forEach((c, j) => {
            if (c) c.toggleAttribute('hidden', j !== i);
          });
          this.citations.forEach((c, j) => {
            if (c) c.toggleAttribute('hidden', j !== i);
          });
        }
      }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["lucide-temoignages"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('lucide-temoignages')) {
    class LucideTemoignages extends HTMLElement {
      connectedCallback() {
        if (this.dataset.pret === '1') return;
        this.dataset.pret = '1';
        this.reserve = this.querySelector('[data-ltm-enfants]');
        this.piste = this.querySelector('[data-ltm-piste]');
        this.fenetre = this.querySelector('[data-ltm-fenetre]');
        this.rail = this.querySelector('[data-ltm-rail]');
        this.ranger();
        this.classList.add('ltm--prete');
        this.preparerAvis();
        this.preparerDefile();
        this.brancherFleches();
        this.brancherEditeur();
      }

      disconnectedCallback() {
        this.actif = false;
        if (this.observateur) this.observateur.disconnect();
      }

      /* Les enfants naissent dans la réserve : on les déplace vers leur zone (patron lucide-experts). */
      ranger() {
        if (!this.reserve) return;
        const enfants = Array.from(this.reserve.querySelectorAll('[data-ltm-media], [data-ltm-avis]'));
        for (const el of enfants) {
          const enveloppe = el.closest('.shopify-block') || el;
          if (el.hasAttribute('data-ltm-media')) {
            if (this.piste) this.piste.appendChild(enveloppe);
          } else if (this.rail) {
            this.rail.appendChild(enveloppe);
          }
        }
      }

      /* ---------- Cartes d'avis : libellé « vérifié », coupe + « Lire plus » ---------- */
      preparerAvis() {
        const verifie = this.dataset.verifie || '';
        const plus = this.dataset.lirePlus || 'Lire plus';
        const moins = this.dataset.lireMoins || 'Lire moins';
        for (const t of this.querySelectorAll('[data-ltm-verifie-texte]')) t.textContent = verifie;
        const cartes = this.rail ? this.rail.querySelectorAll('[data-ltm-avis]') : [];
        for (const carte of cartes) {
          const texte = carte.querySelector('[data-ltm-texte]');
          const bouton = carte.querySelector('[data-ltm-plus]');
          if (!texte || !bouton) continue;
          const coupe = texte.scrollHeight > texte.clientHeight + 2;
          bouton.hidden = !coupe;
          bouton.textContent = plus;
          bouton.addEventListener('click', () => {
            const ouvert = carte.classList.toggle('ltm-avis--ouvert');
            bouton.textContent = ouvert ? moins : plus;
          });
        }
      }

      /* ---------- Rail d'avis : flèches = un cran, snap suspendu le temps du mouvement ---------- */
      cartesAvis() {
        return this.rail ? Array.from(this.rail.querySelectorAll('[data-ltm-avis]')) : [];
      }

      defilerRail(sens) {
        const cartes = this.cartesAvis();
        if (!cartes.length || !this.rail) return;
        const pas = cartes[0].offsetWidth + (cartes[1] ? cartes[1].offsetLeft - cartes[0].offsetLeft - cartes[0].offsetWidth : 0);
        const depart = this.rail.scrollLeft;
        const maxi = this.rail.scrollWidth - this.rail.clientWidth;
        const cible = Math.max(0, Math.min(depart + sens * pas, maxi));
        if (Math.abs(cible - depart) < 1) return;
        const rail = this.rail;
        const snapAvant = rail.style.scrollSnapType;
        rail.style.scrollSnapType = 'none';
        let fini = false;
        const terminer = () => {
          if (fini) return;
          fini = true;
          rail.scrollLeft = cible;
          rail.style.scrollSnapType = snapAvant;
        };
        if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) { terminer(); return; }
        const duree = 340;
        let debut = null;
        const image = (t) => {
          if (fini) return;
          if (debut === null) debut = t;
          const p = Math.min((t - debut) / duree, 1);
          const e = p < 0.5 ? 2 * p * p : 1 - Math.pow(-2 * p + 2, 2) / 2;
          rail.scrollLeft = depart + (cible - depart) * e;
          if (p < 1) requestAnimationFrame(image); else terminer();
        };
        requestAnimationFrame(image);
        setTimeout(terminer, duree + 80);
      }

      /* ---------- Défilé continu : clones pour la boucle, rAF, pause au survol, vidéos muettes ---------- */
      preparerDefile() {
        if (!this.piste || !this.fenetre) return;
        /* Les enveloppes .shopify-block sont en display:contents (0 px) : on mesure les cartes elles-mêmes. */
        this.enveloppes = Array.from(this.piste.children);
        this.originaux = Array.from(this.piste.querySelectorAll('[data-ltm-media]'));
        if (!this.originaux.length) return;
        for (const v of this.piste.querySelectorAll('video')) this.preparerVideo(v);
        this.cloner();
        this.decalage = 0;
        this.reste = 0;
        this.vitesse = parseFloat(this.dataset.vitesse || '100');
        this.sens = this.dataset.sens === 'droite' ? -1 : 1;
        this.pauseSurvol = this.dataset.pause === '1';
        this.enPause = false;
        this.reduit = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
        this.fenetre.addEventListener('mouseenter', () => { if (this.pauseSurvol) this.enPause = true; });
        this.fenetre.addEventListener('mouseleave', () => { this.enPause = false; });
        this.observateur = new IntersectionObserver((entrees) => {
          for (const en of entrees) {
            this.visible = en.isIntersecting;
            if (this.visible) { this.lancer(); this.jouerVideos(true); } else { this.jouerVideos(false); }
          }
        }, { threshold: 0.05 });
        this.observateur.observe(this);
        window.addEventListener('resize', () => { this.largeurBoucle = 0; });
      }

      preparerVideo(v) {
        v.muted = true;
        v.loop = true;
        v.controls = false;
        v.playsInline = true;
        v.setAttribute('playsinline', '');
        v.setAttribute('muted', '');
        v.setAttribute('disablepictureinpicture', '');
        v.setAttribute('tabindex', '-1');
      }

      jouerVideos(oui) {
        for (const v of this.piste.querySelectorAll('video')) {
          if (oui) v.play().catch(() => {}); else v.pause();
        }
      }

      /* Autant de copies qu'il faut pour couvrir deux fois la fenêtre : la boucle est invisible. */
      cloner() {
        for (const copie of this.piste.querySelectorAll('[data-ltm-clone]')) copie.remove();
        const largeurOrig = this.mesurerBoucle();
        if (!largeurOrig) return;
        const besoin = this.fenetre.clientWidth * 2 + largeurOrig;
        let total = largeurOrig;
        let copies = 0;
        while (total < besoin && copies < 8) {
          for (const o of this.enveloppes) {
            const copie = o.cloneNode(true);
            copie.setAttribute('data-ltm-clone', '');
            copie.setAttribute('aria-hidden', 'true');
            for (const v of copie.querySelectorAll('video')) this.preparerVideo(v);
            this.piste.appendChild(copie);
          }
          total += largeurOrig;
          copies += 1;
        }
        this.largeurBoucle = largeurOrig;
      }

      mesurerBoucle() {
        const n = this.originaux.length;
        if (!n) return 0;
        const premier = this.originaux[0];
        const dernier = this.originaux[n - 1];
        const ecart = n > 1 ? this.originaux[1].offsetLeft - premier.offsetLeft - premier.offsetWidth : parseFloat(getComputedStyle(this.piste).gap) || 0;
        return dernier.offsetLeft + dernier.offsetWidth - premier.offsetLeft + ecart;
      }

      lancer() {
        if (this.actif) return;
        this.actif = true;
        let precedent = null;
        const image = (t) => {
          if (!this.actif) return;
          if (!this.visible) { this.actif = false; return; }
          if (precedent === null) precedent = t;
          const dt = Math.min((t - precedent) / 1000, 0.05);
          precedent = t;
          if (!this.largeurBoucle) this.cloner();
          if (!this.largeurBoucle) { this.actif = false; return; }
          const L = this.largeurBoucle;
          if (!this.reduit && !this.enPause) this.decalage += this.vitesse * dt * this.sens;
          if (this.reste) {
            const pas = this.reste * Math.min(1, dt * 6);
            this.decalage += pas;
            this.reste -= pas;
            if (Math.abs(this.reste) < 0.5) { this.decalage += this.reste; this.reste = 0; }
          }
          this.decalage = ((this.decalage % L) + L) % L;
          this.piste.style.transform = 'translate3d(' + (-this.decalage) + 'px, 0, 0)';
          requestAnimationFrame(image);
        };
        requestAnimationFrame(image);
      }

      pousserDefile(sens) {
        const premier = this.originaux && this.originaux[0];
        if (!premier) return;
        const pas = premier.offsetWidth + (parseFloat(getComputedStyle(this.piste).gap) || 0);
        this.reste += sens * pas;
        if (!this.actif && this.visible) this.lancer();
      }

      brancherFleches() {
        const b = (sel, fn) => { const el = this.querySelector(sel); if (el) el.addEventListener('click', fn); };
        b('[data-ltm-media-prec]', () => this.pousserDefile(-1));
        b('[data-ltm-media-suiv]', () => this.pousserDefile(1));
        b('[data-ltm-avis-prec]', () => this.defilerRail(-1));
        b('[data-ltm-avis-suiv]', () => this.defilerRail(1));
      }

      /* Éditeur : sélectionner un bloc le montre. */
      brancherEditeur() {
        document.addEventListener('shopify:block:select', (e) => {
          const bloc = e.target && e.target.closest ? e.target : null;
          if (!bloc || !this.contains(bloc)) return;
          const avis = bloc.querySelector('[data-ltm-avis]') || (bloc.matches('[data-ltm-avis]') ? bloc : null);
          if (avis && this.rail) {
            const rail = this.rail;
            const snapAvant = rail.style.scrollSnapType;
            rail.style.scrollSnapType = 'none';
            rail.scrollLeft = avis.offsetLeft - 2;
            setTimeout(() => { rail.style.scrollSnapType = snapAvant; }, 50);
          }
        });
      }
    }
    customElements.define('lucide-temoignages', LucideTemoignages);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["lucide-videos-temoins"] && !Shopify.designMode) return;
  try {
    
  (function () {
    if (window.lucideVtInit) return;
    window.lucideVtInit = true;

    var etat = null;

    function lesItems(racine) {
      return Array.prototype.slice.call(racine.querySelectorAll('[data-lucide-vt-item]'));
    }

    /* Une seule vidéo SONORE à la fois : coupe toutes les cartes sauf `sauf` —
       en lecture auto on ne coupe pas la boucle, on remet juste en sourdine */
    function couperLesCartes(sauf) {
      Array.prototype.forEach.call(document.querySelectorAll('.lucide-vt-item__scene video'), function (v) {
        if (v === sauf) return;
        var racine = v.closest('[data-lucide-vt]');
        if (racine && racine.classList.contains('lucide-vt--auto')) {
          v.muted = true;
          v.loop = true;
        } else {
          v.pause();
        }
        var carte = v.closest('.lucide-vt-item__carte');
        if (carte) carte.classList.remove('lucide-vt-item__carte--joue');
      });
    }

    /* Installe le clone vidéo dans la carte (lecture directe et lecture auto) */
    function creerScene(carte, muet) {
      var item = carte.closest('[data-lucide-vt-item]');
      var source = item.querySelector('.lucide-vt-item__media video');
      if (!source) return null;
      var scene = document.createElement('span');
      scene.className = 'lucide-vt-item__scene';
      var video = source.cloneNode(true);
      video.muted = muet;
      video.loop = muet;
      video.controls = false;
      scene.appendChild(video);
      carte.appendChild(scene);
      video.addEventListener('ended', function () {
        carte.classList.remove('lucide-vt-item__carte--joue');
        var racine = carte.closest('[data-lucide-vt]');
        if (racine && racine.classList.contains('lucide-vt--auto')) {
          /* fin d'une lecture sonore : retour à la boucle muette */
          video.muted = true;
          video.loop = true;
          video.play().catch(function () {});
        } else {
          scene.remove();
        }
      });
      return video;
    }

    /* Lecture directe dans la carte (réglage « Au clic » = direct).
       En lecture auto, le clic bascule sourdine ↔ son (redémarré du début). */
    function lireDirect(carte) {
      var racine = carte.closest('[data-lucide-vt]');
      var auto = racine.classList.contains('lucide-vt--auto');
      var video = carte.querySelector('.lucide-vt-item__scene video') || creerScene(carte, auto);
      if (!video) return;
      if (auto) {
        if (video.muted) {
          couperLesCartes(video);
          video.muted = false;
          video.loop = false;
          video.currentTime = 0;
          video.play().catch(function () {});
          carte.classList.add('lucide-vt-item__carte--joue');
        } else {
          video.muted = true;
          video.loop = true;
          carte.classList.remove('lucide-vt-item__carte--joue');
        }
        return;
      }
      if (video.paused) {
        couperLesCartes(video);
        video.play().catch(function () {});
        carte.classList.add('lucide-vt-item__carte--joue');
      } else {
        video.pause();
        carte.classList.remove('lucide-vt-item__carte--joue');
      }
    }

    /* Lecture auto au défilement : dès que la section entre à l'écran, toutes les
       vidéos tournent en boucle, muettes ; à la sortie, tout se met en pause. */
    var observateurAuto = null;
    function reveillerAuto(racine) {
      lesItems(racine).forEach(function (item) {
        var carte = item.querySelector('[data-lucide-vt-ouvrir]');
        if (!carte) return;
        var video = carte.querySelector('.lucide-vt-item__scene video') || creerScene(carte, true);
        if (video && video.muted) video.play().catch(function () {});
      });
    }
    function endormirAuto(racine) {
      Array.prototype.forEach.call(racine.querySelectorAll('.lucide-vt-item__scene video'), function (v) {
        v.pause();
        if (!v.muted) {
          v.muted = true;
          v.loop = true;
        }
        var carte = v.closest('.lucide-vt-item__carte');
        if (carte) carte.classList.remove('lucide-vt-item__carte--joue');
      });
    }
    function initAuto() {
      if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;
      var racines = document.querySelectorAll('.lucide-vt--auto');
      if (!racines.length) return;
      if (!observateurAuto) {
        observateurAuto = new IntersectionObserver(function (entrees) {
          entrees.forEach(function (en) {
            if (en.isIntersecting) {
              reveillerAuto(en.target);
            } else {
              endormirAuto(en.target);
            }
          });
        }, { threshold: 0.2 });
      }
      Array.prototype.forEach.call(racines, function (r) { observateurAuto.observe(r); });
    }
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', initAuto);
    } else {
      initAuto();
    }
    document.addEventListener('shopify:section:load', initAuto);

    function montrer(i) {
      var items = etat.items;
      if (!items.length) return;
      etat.i = ((i % items.length) + items.length) % items.length;
      var scene = etat.lecteur.querySelector('[data-lucide-vt-scene]');
      var source = items[etat.i].querySelector('.lucide-vt-item__media video');
      scene.innerHTML = '';
      if (!source) return;
      var video = source.cloneNode(true);
      video.muted = false;
      video.controls = false;
      scene.appendChild(video);
      video.currentTime = 0;
      video.play().catch(function () {});
      video.addEventListener('ended', function () { montrer(etat.i + 1); });
      video.addEventListener('click', function () {
        if (video.paused) { video.play().catch(function () {}); } else { video.pause(); }
      });
    }

    function fermer() {
      if (!etat) return;
      document.documentElement.removeAttribute('scroll-lock');
      try { etat.lecteur.close(); } catch (e) {}
      etat.lecteur.querySelector('[data-lucide-vt-scene]').innerHTML = '';
      etat = null;
    }

    document.addEventListener('click', function (e) {
      var carte = e.target.closest('[data-lucide-vt-ouvrir]');
      if (carte) {
        var racine = carte.closest('[data-lucide-vt]');
        if (racine.classList.contains('lucide-vt--clic-direct')) {
          lireDirect(carte);
          return;
        }
        couperLesCartes(null);
        var items = lesItems(racine);
        var item = carte.closest('[data-lucide-vt-item]');
        etat = {
          lecteur: racine.querySelector('[data-lucide-vt-lecteur]'),
          items: items,
          i: items.indexOf(item)
        };
        try { etat.lecteur.showModal(); } catch (err) {}
        /* Page verrouillée derrière le pop-up (2026-08-22) — verrou natif d'Horizon */
        document.documentElement.setAttribute('scroll-lock', '');
        montrer(etat.i);
        return;
      }
      if (e.target.closest('[data-lucide-vt-fermer]')) { fermer(); return; }
      if (etat && e.target.closest('[data-lucide-vt-avant]')) { montrer(etat.i - 1); return; }
      if (etat && e.target.closest('[data-lucide-vt-apres]')) { montrer(etat.i + 1); return; }
      var prec = e.target.closest('[data-lucide-vt-prec]');
      var suiv = e.target.closest('[data-lucide-vt-suiv]');
      if (prec || suiv) {
        var zone = (prec || suiv).closest('.lucide-vt__zone');
        var rail = zone && zone.querySelector('[data-lucide-vt-rail]');
        if (!rail) return;
        var vignette = rail.querySelector('.lucide-vt-item__carte');
        var pas = vignette ? vignette.getBoundingClientRect().width + 20 : rail.clientWidth / 2;
        rail.scrollBy({ left: prec ? -pas : pas, behavior: 'smooth' });
      }
    });

    /* Glissement dans le lecteur : haut/bas ou gauche/droite selon le réglage */
    var departX = null;
    var departY = null;
    document.addEventListener('touchstart', function (e) {
      if (!etat) return;
      departX = e.touches[0].clientX;
      departY = e.touches[0].clientY;
    }, { passive: true });
    document.addEventListener('touchend', function (e) {
      if (!etat || departY === null) return;
      var racine = etat.lecteur.closest('[data-lucide-vt]');
      var vertical = racine.classList.contains('lucide-vt--nav-verticale');
      var dX = e.changedTouches[0].clientX - departX;
      var dY = e.changedTouches[0].clientY - departY;
      departX = null;
      departY = null;
      var delta = vertical ? dY : dX;
      var autre = vertical ? dX : dY;
      if (Math.abs(delta) < 50 || Math.abs(delta) < Math.abs(autre)) return;
      montrer(delta < 0 ? etat.i + 1 : etat.i - 1);
    }, { passive: true });

    var derniereMolette = 0;
    document.addEventListener('wheel', function (e) {
      if (!etat) return;
      var maintenant = Date.now();
      if (maintenant - derniereMolette < 500) return;
      if (Math.abs(e.deltaY) < 20) return;
      derniereMolette = maintenant;
      montrer(e.deltaY > 0 ? etat.i + 1 : etat.i - 1);
    }, { passive: true });

    document.addEventListener('close', function (e) {
      if (e.target && e.target.matches && e.target.matches('[data-lucide-vt-lecteur]')) {
        e.target.querySelector('[data-lucide-vt-scene]').innerHTML = '';
        etat = null;
      }
    }, true);
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["lucide-votre-journee"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('lucide-votre-journee')) {
    customElements.define(
      'lucide-votre-journee',
      class extends HTMLElement {
        connectedCallback() {
          const zonePhoto = this.querySelector('.lvj__carte-cadre');
          const zoneTitreMoment = this.querySelector('.lvj__zone-titre-moment');
          const zoneTexte = this.querySelector('.lvj__zone-texte');
          const suiv = this.querySelector('[data-lvj-suiv]');
          const prec = this.querySelector('[data-lvj-prec]');
          this.moments = Array.from(this.querySelectorAll('.lvj__moment'));
          if (!zonePhoto || !zoneTitreMoment || !zoneTexte || !this.moments.length) return;
          this.cartes = [];
          this.titres = [];
          this.textes = [];
          this.moments.forEach((m, i) => {
            const carte = m.querySelector('.lvj__carte');
            const titre = m.querySelector('.lvj__titre-moment');
            const texte = m.querySelector('.lvj__texte');
            if (carte) {
              zonePhoto.appendChild(carte);
              this.cartes[i] = carte;
            }
            if (titre) {
              zoneTitreMoment.appendChild(titre);
              this.titres[i] = titre;
            }
            if (texte) {
              zoneTexte.appendChild(texte);
              this.textes[i] = texte;
            }
            const radio = m.querySelector('.lvj__radio');
            if (radio) radio.addEventListener('change', () => this.montrer(i));
          });
          this.i = 0;
          this.montrer(0);
          if (suiv) suiv.addEventListener('click', () => this.montrer(this.i + 1));
          if (prec) prec.addEventListener('click', () => this.montrer(this.i - 1));
          this.addEventListener('shopify:block:select', (e) => {
            const m = e.target && e.target.closest ? e.target.closest('.lvj__moment') : null;
            const i = this.moments.indexOf(m);
            if (i >= 0) this.montrer(i);
          });
        }
        montrer(i) {
          const n = this.moments.length;
          this.i = ((i % n) + n) % n;
          this.cartes.forEach((c, j) => { if (c) c.toggleAttribute('hidden', j !== this.i); });
          this.titres.forEach((t, j) => { if (t) t.toggleAttribute('hidden', j !== this.i); });
          this.textes.forEach((t, j) => { if (t) t.toggleAttribute('hidden', j !== this.i); });
          const radio = this.moments[this.i].querySelector('.lvj__radio');
          if (radio) radio.checked = true;
        }
      }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
